//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class PonderDataClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filename (optional) 
     * @param contentType (optional) 
     * @param contentLength (optional) 
     * @param urlTtl (optional) 
     * @return OK
     */
    artifactGeneratePresignedUrl(filename: string | undefined, contentType: string | undefined, contentLength: number | undefined, urlTtl: number | undefined): Observable<GetPresignedUrlResponse> {
        let url_ = this.baseUrl + "/artifact/generate-presigned-url?";
        if (filename === null)
            throw new Error("The parameter 'filename' cannot be null.");
        else if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        if (contentLength === null)
            throw new Error("The parameter 'contentLength' cannot be null.");
        else if (contentLength !== undefined)
            url_ += "contentLength=" + encodeURIComponent("" + contentLength) + "&";
        if (urlTtl === null)
            throw new Error("The parameter 'urlTtl' cannot be null.");
        else if (urlTtl !== undefined)
            url_ += "urlTtl=" + encodeURIComponent("" + urlTtl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifactGeneratePresignedUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifactGeneratePresignedUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPresignedUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPresignedUrlResponse>;
        }));
    }

    protected processArtifactGeneratePresignedUrl(response: HttpResponseBase): Observable<GetPresignedUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPresignedUrlResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPresignedUrlResponse>(null as any);
    }

    /**
     * @param contentType (optional) 
     * @param contentLength (optional) 
     * @return OK
     */
    artifactGeneratePresignedUrlProfileImage(contentType: string | undefined, contentLength: number | undefined): Observable<GetPresignedUrlResponse> {
        let url_ = this.baseUrl + "/artifact/generate-presigned-url/profile-image?";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        if (contentLength === null)
            throw new Error("The parameter 'contentLength' cannot be null.");
        else if (contentLength !== undefined)
            url_ += "contentLength=" + encodeURIComponent("" + contentLength) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifactGeneratePresignedUrlProfileImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifactGeneratePresignedUrlProfileImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPresignedUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPresignedUrlResponse>;
        }));
    }

    protected processArtifactGeneratePresignedUrlProfileImage(response: HttpResponseBase): Observable<GetPresignedUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPresignedUrlResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPresignedUrlResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @param userId (optional) 
     * @param collectionId (optional) 
     * @return OK
     */
    collection(username: string | undefined, userId: string | undefined, collectionId: string | undefined): Observable<GetCollectionResponse> {
        let url_ = this.baseUrl + "/collection?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (collectionId === null)
            throw new Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "collectionId=" + encodeURIComponent("" + collectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCollectionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCollectionResponse>;
        }));
    }

    protected processCollection(response: HttpResponseBase): Observable<GetCollectionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCollectionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCollectionResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @param gameId (optional) 
     * @param itemTypeId (optional) 
     * @return OK
     */
    collectionValue(username: string | undefined, gameId: number | undefined, itemTypeId: number | undefined): Observable<GetCollectionValueResponse> {
        let url_ = this.baseUrl + "/collection/value?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (gameId === null)
            throw new Error("The parameter 'gameId' cannot be null.");
        else if (gameId !== undefined)
            url_ += "gameId=" + encodeURIComponent("" + gameId) + "&";
        if (itemTypeId === null)
            throw new Error("The parameter 'itemTypeId' cannot be null.");
        else if (itemTypeId !== undefined)
            url_ += "itemTypeId=" + encodeURIComponent("" + itemTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollectionValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollectionValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCollectionValueResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCollectionValueResponse>;
        }));
    }

    protected processCollectionValue(response: HttpResponseBase): Observable<GetCollectionValueResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCollectionValueResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCollectionValueResponse>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param count (optional) 
     * @param specialCount (optional) 
     * @param proxyCount (optional) 
     * @param gameId (optional) 
     * @param itemTypeId (optional) 
     * @return OK
     */
    collectionItem(itemId: string | undefined, count: number | undefined, specialCount: number | undefined, proxyCount: number | undefined, gameId: number | undefined, itemTypeId: number | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/collection/item?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (specialCount === null)
            throw new Error("The parameter 'specialCount' cannot be null.");
        else if (specialCount !== undefined)
            url_ += "specialCount=" + encodeURIComponent("" + specialCount) + "&";
        if (proxyCount === null)
            throw new Error("The parameter 'proxyCount' cannot be null.");
        else if (proxyCount !== undefined)
            url_ += "proxyCount=" + encodeURIComponent("" + proxyCount) + "&";
        if (gameId === null)
            throw new Error("The parameter 'gameId' cannot be null.");
        else if (gameId !== undefined)
            url_ += "gameId=" + encodeURIComponent("" + gameId) + "&";
        if (itemTypeId === null)
            throw new Error("The parameter 'itemTypeId' cannot be null.");
        else if (itemTypeId !== undefined)
            url_ += "itemTypeId=" + encodeURIComponent("" + itemTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollectionItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollectionItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processCollectionItem(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    collectionPreview(username: string | undefined): Observable<GetCollectionPreviewResponse> {
        let url_ = this.baseUrl + "/collection/preview?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollectionPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollectionPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCollectionPreviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCollectionPreviewResponse>;
        }));
    }

    protected processCollectionPreview(response: HttpResponseBase): Observable<GetCollectionPreviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCollectionPreviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCollectionPreviewResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    collectionSnapshots(username: string | undefined, from: Date | undefined, to: Date | undefined): Observable<GetCollectionSnapshotResponse> {
        let url_ = this.baseUrl + "/collection/snapshots?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCollectionSnapshots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollectionSnapshots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCollectionSnapshotResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCollectionSnapshotResponse>;
        }));
    }

    protected processCollectionSnapshots(response: HttpResponseBase): Observable<GetCollectionSnapshotResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCollectionSnapshotResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCollectionSnapshotResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    decks(username: string | undefined): Observable<GetDecksResponse> {
        let url_ = this.baseUrl + "/decks?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDecksResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDecksResponse>;
        }));
    }

    protected processDecks(response: HttpResponseBase): Observable<GetDecksResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDecksResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDecksResponse>(null as any);
    }

    /**
     * @param game (optional) 
     * @param set (optional) 
     * @return OK
     */
    decksPrecon(game: GameType | undefined, set: string | undefined): Observable<GetDecksResponse> {
        let url_ = this.baseUrl + "/decks/precon?";
        if (game === null)
            throw new Error("The parameter 'game' cannot be null.");
        else if (game !== undefined)
            url_ += "game=" + encodeURIComponent("" + game) + "&";
        if (set === null)
            throw new Error("The parameter 'set' cannot be null.");
        else if (set !== undefined)
            url_ += "set=" + encodeURIComponent("" + set) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecksPrecon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecksPrecon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDecksResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDecksResponse>;
        }));
    }

    protected processDecksPrecon(response: HttpResponseBase): Observable<GetDecksResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDecksResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDecksResponse>(null as any);
    }

    /**
     * @return OK
     */
    deck(deckId: string): Observable<GetDeckResponse> {
        let url_ = this.baseUrl + "/deck/{deckId}";
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDeckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDeckResponse>;
        }));
    }

    protected processDeck(response: HttpResponseBase): Observable<GetDeckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeckResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeckResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deckUpdate(body: UpdateDeckRequest | undefined): Observable<UpdateDeckResponse> {
        let url_ = this.baseUrl + "/deck/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeckUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeckUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateDeckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateDeckResponse>;
        }));
    }

    protected processDeckUpdate(response: HttpResponseBase): Observable<UpdateDeckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDeckResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateDeckResponse>(null as any);
    }

    /**
     * @return OK
     */
    deckDelete(deckId: string): Observable<DataResponse> {
        let url_ = this.baseUrl + "/deck/delete/{deckId}";
        if (deckId === undefined || deckId === null)
            throw new Error("The parameter 'deckId' must be defined.");
        url_ = url_.replace("{deckId}", encodeURIComponent("" + deckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeckDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeckDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processDeckDelete(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @return OK
     */
    deckCheck(): Observable<DataResponse> {
        let url_ = this.baseUrl + "/deck/check";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeckCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeckCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processDeckCheck(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deckCreate(body: CreateDeckRequest | undefined): Observable<CreateDeckResponse> {
        let url_ = this.baseUrl + "/deck/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeckCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeckCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDeckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDeckResponse>;
        }));
    }

    protected processDeckCreate(response: HttpResponseBase): Observable<CreateDeckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateDeckResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateDeckResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deckCopy(body: CopyDeckRequest | undefined): Observable<CreateDeckResponse> {
        let url_ = this.baseUrl + "/deck/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeckCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeckCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDeckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDeckResponse>;
        }));
    }

    protected processDeckCopy(response: HttpResponseBase): Observable<CreateDeckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateDeckResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateDeckResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deckImport(body: ImportDeckRequest | undefined): Observable<CreateDeckResponse> {
        let url_ = this.baseUrl + "/deck/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeckImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeckImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDeckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDeckResponse>;
        }));
    }

    protected processDeckImport(response: HttpResponseBase): Observable<CreateDeckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateDeckResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateDeckResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deckImportPrecon(body: ImportPreconDeckRequest | undefined): Observable<CreateDeckResponse> {
        let url_ = this.baseUrl + "/deck/import/precon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeckImportPrecon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeckImportPrecon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDeckResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDeckResponse>;
        }));
    }

    protected processDeckImportPrecon(response: HttpResponseBase): Observable<CreateDeckResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateDeckResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateDeckResponse>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    deckGroupRename(from: string | undefined, to: string | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/deck-group/rename?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeckGroupRename(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeckGroupRename(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processDeckGroupRename(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param game (optional) 
     * @param cardName (optional) 
     * @return OK
     */
    decksWithCard(game: GameType | undefined, cardName: string | undefined): Observable<GetDecksWithCardResponse> {
        let url_ = this.baseUrl + "/decks-with-card?";
        if (game === null)
            throw new Error("The parameter 'game' cannot be null.");
        else if (game !== undefined)
            url_ += "game=" + encodeURIComponent("" + game) + "&";
        if (cardName === null)
            throw new Error("The parameter 'cardName' cannot be null.");
        else if (cardName !== undefined)
            url_ += "cardName=" + encodeURIComponent("" + cardName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecksWithCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecksWithCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDecksWithCardResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDecksWithCardResponse>;
        }));
    }

    protected processDecksWithCard(response: HttpResponseBase): Observable<GetDecksWithCardResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDecksWithCardResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDecksWithCardResponse>(null as any);
    }

    /**
     * @param game (optional) 
     * @param itemId (optional) 
     * @return OK
     */
    decksWithCardAll(game: GameType | undefined, itemId: string | undefined): Observable<GetDeckCardCountsResponse> {
        let url_ = this.baseUrl + "/decks-with-card/all?";
        if (game === null)
            throw new Error("The parameter 'game' cannot be null.");
        else if (game !== undefined)
            url_ += "game=" + encodeURIComponent("" + game) + "&";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecksWithCardAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecksWithCardAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDeckCardCountsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDeckCardCountsResponse>;
        }));
    }

    protected processDecksWithCardAll(response: HttpResponseBase): Observable<GetDeckCardCountsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeckCardCountsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeckCardCountsResponse>(null as any);
    }

    /**
     * @return OK
     */
    health(): Observable<void> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param isAnnieOk (optional) 
     * @return OK
     */
    healthAnnie(isAnnieOk: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/health/annie?";
        if (isAnnieOk === null)
            throw new Error("The parameter 'isAnnieOk' cannot be null.");
        else if (isAnnieOk !== undefined)
            url_ += "isAnnieOk=" + encodeURIComponent("" + isAnnieOk) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealthAnnie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealthAnnie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHealthAnnie(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @return OK
     */
    itemRoute(itemId: string | undefined): Observable<GetItemRouteResponse> {
        let url_ = this.baseUrl + "/item/route?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processItemRoute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processItemRoute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetItemRouteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetItemRouteResponse>;
        }));
    }

    protected processItemRoute(response: HttpResponseBase): Observable<GetItemRouteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetItemRouteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetItemRouteResponse>(null as any);
    }

    /**
     * @return OK
     */
    itemFeatured(): Observable<GetFeaturedCardsResponse> {
        let url_ = this.baseUrl + "/item/featured";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processItemFeatured(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processItemFeatured(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFeaturedCardsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFeaturedCardsResponse>;
        }));
    }

    protected processItemFeatured(response: HttpResponseBase): Observable<GetFeaturedCardsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFeaturedCardsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFeaturedCardsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    magicCard(body: GetMagicCardRequest | undefined): Observable<GetMagicCardResponse> {
        let url_ = this.baseUrl + "/magic/card";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMagicCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMagicCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMagicCardResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMagicCardResponse>;
        }));
    }

    protected processMagicCard(response: HttpResponseBase): Observable<GetMagicCardResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMagicCardResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMagicCardResponse>(null as any);
    }

    /**
     * @param oracleId (optional) 
     * @return OK
     */
    magicCardRulings(oracleId: string | undefined): Observable<GetMagicCardRulingsResponse> {
        let url_ = this.baseUrl + "/magic/card/rulings?";
        if (oracleId === null)
            throw new Error("The parameter 'oracleId' cannot be null.");
        else if (oracleId !== undefined)
            url_ += "oracleId=" + encodeURIComponent("" + oracleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMagicCardRulings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMagicCardRulings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMagicCardRulingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMagicCardRulingsResponse>;
        }));
    }

    protected processMagicCardRulings(response: HttpResponseBase): Observable<GetMagicCardRulingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMagicCardRulingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMagicCardRulingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    magicCardUpdate(body: UpdateMagicCardRequest | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/magic/card/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMagicCardUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMagicCardUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processMagicCardUpdate(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    magicCollectionStats(username: string | undefined): Observable<GetMagicCollectionCardsForStatsResponse> {
        let url_ = this.baseUrl + "/magic/collection/stats?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMagicCollectionStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMagicCollectionStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMagicCollectionCardsForStatsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMagicCollectionCardsForStatsResponse>;
        }));
    }

    protected processMagicCollectionStats(response: HttpResponseBase): Observable<GetMagicCollectionCardsForStatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMagicCollectionCardsForStatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMagicCollectionCardsForStatsResponse>(null as any);
    }

    /**
     * @param setCode (optional) 
     * @return OK
     */
    magicSet(setCode: string | undefined): Observable<GetMagicSetResponse> {
        let url_ = this.baseUrl + "/magic/set?";
        if (setCode === null)
            throw new Error("The parameter 'setCode' cannot be null.");
        else if (setCode !== undefined)
            url_ += "setCode=" + encodeURIComponent("" + setCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMagicSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMagicSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMagicSetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMagicSetResponse>;
        }));
    }

    protected processMagicSet(response: HttpResponseBase): Observable<GetMagicSetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMagicSetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMagicSetResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    magicSetNew(body: CreateMagicSetRequest | undefined): Observable<CreateMagicSetResponse> {
        let url_ = this.baseUrl + "/magic/set/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMagicSetNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMagicSetNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMagicSetResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMagicSetResponse>;
        }));
    }

    protected processMagicSetNew(response: HttpResponseBase): Observable<CreateMagicSetResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMagicSetResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateMagicSetResponse>(null as any);
    }

    /**
     * @param blockCode (optional) 
     * @return OK
     */
    magicBlock(blockCode: string | undefined): Observable<GetMagicBlockResponse> {
        let url_ = this.baseUrl + "/magic/block?";
        if (blockCode === null)
            throw new Error("The parameter 'blockCode' cannot be null.");
        else if (blockCode !== undefined)
            url_ += "blockCode=" + encodeURIComponent("" + blockCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMagicBlock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMagicBlock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMagicBlockResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMagicBlockResponse>;
        }));
    }

    protected processMagicBlock(response: HttpResponseBase): Observable<GetMagicBlockResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMagicBlockResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMagicBlockResponse>(null as any);
    }

    /**
     * @return OK
     */
    magicSetAll(): Observable<GetMagicSetsResponse> {
        let url_ = this.baseUrl + "/magic/set/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMagicSetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMagicSetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMagicSetsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMagicSetsResponse>;
        }));
    }

    protected processMagicSetAll(response: HttpResponseBase): Observable<GetMagicSetsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMagicSetsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMagicSetsResponse>(null as any);
    }

    /**
     * @param start (optional) 
     * @param limit (optional) 
     * @param truncate (optional) 
     * @return OK
     */
    newsPosts(start: number | undefined, limit: number | undefined, truncate: boolean | undefined): Observable<GetNewsPostsResponse> {
        let url_ = this.baseUrl + "/news/posts?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (truncate === null)
            throw new Error("The parameter 'truncate' cannot be null.");
        else if (truncate !== undefined)
            url_ += "truncate=" + encodeURIComponent("" + truncate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsPosts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsPosts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNewsPostsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNewsPostsResponse>;
        }));
    }

    protected processNewsPosts(response: HttpResponseBase): Observable<GetNewsPostsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsPostsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNewsPostsResponse>(null as any);
    }

    /**
     * @return OK
     */
    newsPostGet(postId: string): Observable<GetNewsPostResponse> {
        let url_ = this.baseUrl + "/news/post?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined and cannot be null.");
        else
            url_ += "postId=" + encodeURIComponent("" + postId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsPostGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsPostGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNewsPostResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNewsPostResponse>;
        }));
    }

    protected processNewsPostGet(response: HttpResponseBase): Observable<GetNewsPostResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsPostResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNewsPostResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    newsPostPost(body: CreateNewsPostRequest | undefined): Observable<CreateNewsPostResponse> {
        let url_ = this.baseUrl + "/news/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsPostPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsPostPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateNewsPostResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateNewsPostResponse>;
        }));
    }

    protected processNewsPostPost(response: HttpResponseBase): Observable<CreateNewsPostResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateNewsPostResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateNewsPostResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    newsPostPatch(body: UpdateNewsPostRequest | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/news/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsPostPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsPostPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processNewsPostPatch(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @return OK
     */
    newsPostDelete(postId: string): Observable<DataResponse> {
        let url_ = this.baseUrl + "/news/post?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined and cannot be null.");
        else
            url_ += "postId=" + encodeURIComponent("" + postId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsPostDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsPostDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processNewsPostDelete(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @return OK
     */
    newsStubs(): Observable<GetNewsPostStubsResponse> {
        let url_ = this.baseUrl + "/news/stubs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsStubs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsStubs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNewsPostStubsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNewsPostStubsResponse>;
        }));
    }

    protected processNewsStubs(response: HttpResponseBase): Observable<GetNewsPostStubsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsPostStubsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNewsPostStubsResponse>(null as any);
    }

    /**
     * @return OK
     */
    notification(): Observable<GetNotificationsResponse> {
        let url_ = this.baseUrl + "/notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsResponse>;
        }));
    }

    protected processNotification(response: HttpResponseBase): Observable<GetNotificationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    notificationGlobaL(body: CreateGlobalNotificationRequest | undefined): Observable<CreateNotificationResponse> {
        let url_ = this.baseUrl + "/notification/globaL";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationGlobaL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationGlobaL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateNotificationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateNotificationResponse>;
        }));
    }

    protected processNotificationGlobaL(response: HttpResponseBase): Observable<CreateNotificationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateNotificationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateNotificationResponse>(null as any);
    }

    /**
     * @param notificationId (optional) 
     * @return OK
     */
    notificationGlobal(notificationId: string | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/notification/global?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationGlobal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationGlobal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processNotificationGlobal(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param notificationId (optional) 
     * @return OK
     */
    notificationUser(notificationId: string | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/notification/user?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processNotificationUser(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param type (optional) 
     * @return OK
     */
    notificationUserType(type: NotificationType | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/notification/user/type?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationUserType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationUserType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processNotificationUserType(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: SearchRequest | undefined): Observable<SearchResponse> {
        let url_ = this.baseUrl + "/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchResponse>(null as any);
    }

    /**
     * @param name (optional) 
     * @param context (optional) 
     * @return OK
     */
    searchUser(name: string | undefined, context: UserSearchContext | undefined): Observable<UserSearchResponse> {
        let url_ = this.baseUrl + "/search/user?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (context === null)
            throw new Error("The parameter 'context' cannot be null.");
        else if (context !== undefined)
            url_ += "context=" + encodeURIComponent("" + context) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSearchResponse>;
        }));
    }

    protected processSearchUser(response: HttpResponseBase): Observable<UserSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSearchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchSimple(body: SimpleSearchRequest | undefined): Observable<SimpleSearchResponse> {
        let url_ = this.baseUrl + "/search/simple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSimple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSimple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimpleSearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimpleSearchResponse>;
        }));
    }

    protected processSearchSimple(response: HttpResponseBase): Observable<SimpleSearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleSearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SimpleSearchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    searchAdvanced(body: AdvancedSearchRequest | undefined): Observable<SearchResponse> {
        let url_ = this.baseUrl + "/search/advanced";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAdvanced(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAdvanced(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchResponse>;
        }));
    }

    protected processSearchAdvanced(response: HttpResponseBase): Observable<SearchResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    userProfileGet(username: string | undefined): Observable<GetUserProfileResponse> {
        let url_ = this.baseUrl + "/user/profile?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserProfileGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserProfileGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserProfileResponse>;
        }));
    }

    protected processUserProfileGet(response: HttpResponseBase): Observable<GetUserProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserProfileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userProfilePatch(body: UpdateUserProfileRequest | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/user/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserProfilePatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserProfilePatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processUserProfilePatch(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @return OK
     */
    userAvatar(itemId: string | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/user/avatar?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processUserAvatar(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @return OK
     */
    userRelationships(): Observable<GetUserRelationshipsResponse> {
        let url_ = this.baseUrl + "/user/relationships";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserRelationships(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserRelationships(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserRelationshipsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserRelationshipsResponse>;
        }));
    }

    protected processUserRelationships(response: HttpResponseBase): Observable<GetUserRelationshipsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserRelationshipsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserRelationshipsResponse>(null as any);
    }

    /**
     * @param otherUserId (optional) 
     * @return OK
     */
    userFriendAdd(otherUserId: string | undefined): Observable<AddFriendResponse> {
        let url_ = this.baseUrl + "/user/friend/add?";
        if (otherUserId === null)
            throw new Error("The parameter 'otherUserId' cannot be null.");
        else if (otherUserId !== undefined)
            url_ += "otherUserId=" + encodeURIComponent("" + otherUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserFriendAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserFriendAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddFriendResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddFriendResponse>;
        }));
    }

    protected processUserFriendAdd(response: HttpResponseBase): Observable<AddFriendResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddFriendResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddFriendResponse>(null as any);
    }

    /**
     * @param otherUserId (optional) 
     * @return OK
     */
    userFriendAccept(otherUserId: string | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/user/friend/accept?";
        if (otherUserId === null)
            throw new Error("The parameter 'otherUserId' cannot be null.");
        else if (otherUserId !== undefined)
            url_ += "otherUserId=" + encodeURIComponent("" + otherUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserFriendAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserFriendAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processUserFriendAccept(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param otherUserId (optional) 
     * @return OK
     */
    userFriendDelete(otherUserId: string | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/user/friend/delete?";
        if (otherUserId === null)
            throw new Error("The parameter 'otherUserId' cannot be null.");
        else if (otherUserId !== undefined)
            url_ += "otherUserId=" + encodeURIComponent("" + otherUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserFriendDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserFriendDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processUserFriendDelete(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @param resource (optional) 
     * @return OK
     */
    userResourceVisibility(username: string | undefined, resource: UserProtectedResource | undefined): Observable<GetUserResourceVisibilityResponse> {
        let url_ = this.baseUrl + "/user/resource-visibility?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (resource === null)
            throw new Error("The parameter 'resource' cannot be null.");
        else if (resource !== undefined)
            url_ += "resource=" + encodeURIComponent("" + resource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserResourceVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserResourceVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserResourceVisibilityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserResourceVisibilityResponse>;
        }));
    }

    protected processUserResourceVisibility(response: HttpResponseBase): Observable<GetUserResourceVisibilityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserResourceVisibilityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserResourceVisibilityResponse>(null as any);
    }

    /**
     * @return OK
     */
    userSettingsPrivacyGet(): Observable<GetUserPrivacySettingsResponse> {
        let url_ = this.baseUrl + "/user/settings/privacy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSettingsPrivacyGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSettingsPrivacyGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPrivacySettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPrivacySettingsResponse>;
        }));
    }

    protected processUserSettingsPrivacyGet(response: HttpResponseBase): Observable<GetUserPrivacySettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPrivacySettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserPrivacySettingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userSettingsPrivacyPatch(body: UpdateUserPrivacySettingsRequest | undefined): Observable<UpdateUserPrivacySettingsResponse> {
        let url_ = this.baseUrl + "/user/settings/privacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSettingsPrivacyPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSettingsPrivacyPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserPrivacySettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserPrivacySettingsResponse>;
        }));
    }

    protected processUserSettingsPrivacyPatch(response: HttpResponseBase): Observable<UpdateUserPrivacySettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserPrivacySettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserPrivacySettingsResponse>(null as any);
    }

    /**
     * @param game (optional) 
     * @param start (optional) 
     * @param count (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param name (optional) 
     * @param exactName (optional) 
     * @return OK
     */
    userActionsCollection(game: GameType | undefined, start: number | undefined, count: number | undefined, startDate: Date | undefined, endDate: Date | undefined, name: string | undefined, exactName: boolean | undefined): Observable<GetUserCollectionActionsResponse> {
        let url_ = this.baseUrl + "/user/actions/collection?";
        if (game === null)
            throw new Error("The parameter 'game' cannot be null.");
        else if (game !== undefined)
            url_ += "game=" + encodeURIComponent("" + game) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (exactName === null)
            throw new Error("The parameter 'exactName' cannot be null.");
        else if (exactName !== undefined)
            url_ += "exactName=" + encodeURIComponent("" + exactName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActionsCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActionsCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserCollectionActionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserCollectionActionsResponse>;
        }));
    }

    protected processUserActionsCollection(response: HttpResponseBase): Observable<GetUserCollectionActionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserCollectionActionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserCollectionActionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userActionsCollectionUndo(body: UndoUserCollectionActionsRequest | undefined): Observable<DataResponse> {
        let url_ = this.baseUrl + "/user/actions/collection/undo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActionsCollectionUndo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActionsCollectionUndo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processUserActionsCollectionUndo(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataResponse>(null as any);
    }
}

export class AddFriendResponse implements IAddFriendResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    friend?: UserRelationship;

    constructor(data?: IAddFriendResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.friend = _data["friend"] ? UserRelationship.fromJS(_data["friend"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddFriendResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddFriendResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["friend"] = this.friend ? this.friend.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddFriendResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    friend?: UserRelationship;
}

export class AdvancedSearchRequest implements IAdvancedSearchRequest {
    start?: number;
    limit?: number;
    magicParameters?: MagicAdvancedSearchParameters;

    constructor(data?: IAdvancedSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"];
            this.limit = _data["limit"];
            this.magicParameters = _data["magicParameters"] ? MagicAdvancedSearchParameters.fromJS(_data["magicParameters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdvancedSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start;
        data["limit"] = this.limit;
        data["magicParameters"] = this.magicParameters ? this.magicParameters.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdvancedSearchRequest {
    start?: number;
    limit?: number;
    magicParameters?: MagicAdvancedSearchParameters;
}

export class ArrayParameter implements IArrayParameter {
    logicalAnd!: boolean;
    values!: string[] | undefined;

    constructor(data?: IArrayParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logicalAnd = _data["logicalAnd"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): ArrayParameter {
        data = typeof data === 'object' ? data : {};
        let result = new ArrayParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logicalAnd"] = this.logicalAnd;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IArrayParameter {
    logicalAnd: boolean;
    values: string[] | undefined;
}

export class Artist implements IArtist {
    id!: string;
    name!: string | undefined;

    constructor(data?: IArtist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Artist {
        data = typeof data === 'object' ? data : {};
        let result = new Artist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IArtist {
    id: string;
    name: string | undefined;
}

export class ArtistSearch implements IArtistSearch {
    name!: string | undefined;

    constructor(data?: IArtistSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ArtistSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ArtistSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IArtistSearch {
    name: string | undefined;
}

export class CardInDeck implements ICardInDeck {
    deckId!: string;
    deckName!: string | undefined;
    deckColor!: string | undefined;
    backgroundCardId?: string | undefined;
    layer!: string | undefined;
    deckCard!: DeckCard;

    constructor(data?: ICardInDeck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.deckCard = new DeckCard();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deckId = _data["deckId"];
            this.deckName = _data["deckName"];
            this.deckColor = _data["deckColor"];
            this.backgroundCardId = _data["backgroundCardId"];
            this.layer = _data["layer"];
            this.deckCard = _data["deckCard"] ? DeckCard.fromJS(_data["deckCard"]) : new DeckCard();
        }
    }

    static fromJS(data: any): CardInDeck {
        data = typeof data === 'object' ? data : {};
        let result = new CardInDeck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deckId"] = this.deckId;
        data["deckName"] = this.deckName;
        data["deckColor"] = this.deckColor;
        data["backgroundCardId"] = this.backgroundCardId;
        data["layer"] = this.layer;
        data["deckCard"] = this.deckCard ? this.deckCard.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICardInDeck {
    deckId: string;
    deckName: string | undefined;
    deckColor: string | undefined;
    backgroundCardId?: string | undefined;
    layer: string | undefined;
    deckCard: DeckCard;
}

export class CollectedItemDetails implements ICollectedItemDetails {
    id?: string;
    count?: number;
    specialCount?: number;
    proxyCount?: number;

    constructor(data?: ICollectedItemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            this.specialCount = _data["specialCount"];
            this.proxyCount = _data["proxyCount"];
        }
    }

    static fromJS(data: any): CollectedItemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CollectedItemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        data["specialCount"] = this.specialCount;
        data["proxyCount"] = this.proxyCount;
        return data;
    }
}

export interface ICollectedItemDetails {
    id?: string;
    count?: number;
    specialCount?: number;
    proxyCount?: number;
}

export class CollectedMagicCard implements ICollectedMagicCard {
    card!: MagicCard;
    collected?: CollectedItemDetails;
    price!: Price;

    constructor(data?: ICollectedMagicCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.card = new MagicCard();
            this.price = new Price();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.card = _data["card"] ? MagicCard.fromJS(_data["card"]) : new MagicCard();
            this.collected = _data["collected"] ? CollectedItemDetails.fromJS(_data["collected"]) : <any>undefined;
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : new Price();
        }
    }

    static fromJS(data: any): CollectedMagicCard {
        data = typeof data === 'object' ? data : {};
        let result = new CollectedMagicCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["collected"] = this.collected ? this.collected.toJSON() : <any>undefined;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICollectedMagicCard {
    card: MagicCard;
    collected?: CollectedItemDetails;
    price: Price;
}

export class CollectedPreviewItem implements ICollectedPreviewItem {
    item!: PreviewItem;
    collected?: CollectedItemDetails;
    price!: Price;

    constructor(data?: ICollectedPreviewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.item = new PreviewItem();
            this.price = new Price();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? PreviewItem.fromJS(_data["item"]) : new PreviewItem();
            this.collected = _data["collected"] ? CollectedItemDetails.fromJS(_data["collected"]) : <any>undefined;
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : new Price();
        }
    }

    static fromJS(data: any): CollectedPreviewItem {
        data = typeof data === 'object' ? data : {};
        let result = new CollectedPreviewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["collected"] = this.collected ? this.collected.toJSON() : <any>undefined;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICollectedPreviewItem {
    item: PreviewItem;
    collected?: CollectedItemDetails;
    price: Price;
}

export class Collection implements ICollection {
    id?: string;
    owner?: string;

    constructor(data?: ICollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.owner = _data["owner"];
        }
    }

    static fromJS(data: any): Collection {
        data = typeof data === 'object' ? data : {};
        let result = new Collection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["owner"] = this.owner;
        return data;
    }
}

export interface ICollection {
    id?: string;
    owner?: string;
}

export class CollectionPreview implements ICollectionPreview {
    game!: GameType;
    total!: number;
    distinct!: number;
    valueUSD!: number;
    topItems!: CollectedPreviewItem[] | undefined;

    constructor(data?: ICollectionPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.game = _data["game"];
            this.total = _data["total"];
            this.distinct = _data["distinct"];
            this.valueUSD = _data["valueUSD"];
            if (Array.isArray(_data["topItems"])) {
                this.topItems = [] as any;
                for (let item of _data["topItems"])
                    this.topItems!.push(CollectedPreviewItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CollectionPreview {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["game"] = this.game;
        data["total"] = this.total;
        data["distinct"] = this.distinct;
        data["valueUSD"] = this.valueUSD;
        if (Array.isArray(this.topItems)) {
            data["topItems"] = [];
            for (let item of this.topItems)
                data["topItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICollectionPreview {
    game: GameType;
    total: number;
    distinct: number;
    valueUSD: number;
    topItems: CollectedPreviewItem[] | undefined;
}

export class CollectionSnapshot implements ICollectionSnapshot {
    game!: GameType;
    itemType!: ItemType;
    snapshotDate!: Date;
    itemCount!: number;
    distinctCount!: number;
    value!: number;

    constructor(data?: ICollectionSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.game = _data["game"];
            this.itemType = _data["itemType"];
            this.snapshotDate = _data["snapshotDate"] ? new Date(_data["snapshotDate"].toString()) : <any>undefined;
            this.itemCount = _data["itemCount"];
            this.distinctCount = _data["distinctCount"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CollectionSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["game"] = this.game;
        data["itemType"] = this.itemType;
        data["snapshotDate"] = this.snapshotDate ? formatDate(this.snapshotDate) : <any>undefined;
        data["itemCount"] = this.itemCount;
        data["distinctCount"] = this.distinctCount;
        data["value"] = this.value;
        return data;
    }
}

export interface ICollectionSnapshot {
    game: GameType;
    itemType: ItemType;
    snapshotDate: Date;
    itemCount: number;
    distinctCount: number;
    value: number;
}

export class CollectionSnapshotGameGroup implements ICollectionSnapshotGameGroup {
    game!: GameType;
    itemGroups!: CollectionSnapshotItemGroup[] | undefined;

    constructor(data?: ICollectionSnapshotGameGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.game = _data["game"];
            if (Array.isArray(_data["itemGroups"])) {
                this.itemGroups = [] as any;
                for (let item of _data["itemGroups"])
                    this.itemGroups!.push(CollectionSnapshotItemGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CollectionSnapshotGameGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionSnapshotGameGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["game"] = this.game;
        if (Array.isArray(this.itemGroups)) {
            data["itemGroups"] = [];
            for (let item of this.itemGroups)
                data["itemGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICollectionSnapshotGameGroup {
    game: GameType;
    itemGroups: CollectionSnapshotItemGroup[] | undefined;
}

export class CollectionSnapshotItemGroup implements ICollectionSnapshotItemGroup {
    item!: ItemType;
    snapshots!: CollectionSnapshot[] | undefined;

    constructor(data?: ICollectionSnapshotItemGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"];
            if (Array.isArray(_data["snapshots"])) {
                this.snapshots = [] as any;
                for (let item of _data["snapshots"])
                    this.snapshots!.push(CollectionSnapshot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CollectionSnapshotItemGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionSnapshotItemGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item;
        if (Array.isArray(this.snapshots)) {
            data["snapshots"] = [];
            for (let item of this.snapshots)
                data["snapshots"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICollectionSnapshotItemGroup {
    item: ItemType;
    snapshots: CollectionSnapshot[] | undefined;
}

export class ColorParameter implements IColorParameter {
    logicalAnd!: boolean;
    white?: boolean | undefined;
    blue?: boolean | undefined;
    black?: boolean | undefined;
    red?: boolean | undefined;
    green?: boolean | undefined;
    colorless?: boolean | undefined;

    constructor(data?: IColorParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logicalAnd = _data["logicalAnd"];
            this.white = _data["white"];
            this.blue = _data["blue"];
            this.black = _data["black"];
            this.red = _data["red"];
            this.green = _data["green"];
            this.colorless = _data["colorless"];
        }
    }

    static fromJS(data: any): ColorParameter {
        data = typeof data === 'object' ? data : {};
        let result = new ColorParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logicalAnd"] = this.logicalAnd;
        data["white"] = this.white;
        data["blue"] = this.blue;
        data["black"] = this.black;
        data["red"] = this.red;
        data["green"] = this.green;
        data["colorless"] = this.colorless;
        return data;
    }
}

export interface IColorParameter {
    logicalAnd: boolean;
    white?: boolean | undefined;
    blue?: boolean | undefined;
    black?: boolean | undefined;
    red?: boolean | undefined;
    green?: boolean | undefined;
    colorless?: boolean | undefined;
}

export class CopyDeckRequest implements ICopyDeckRequest {
    deckId!: string;
    name!: string | undefined;
    visibility!: VisibilityType;
    group!: string | undefined;
    color!: string | undefined;
    addToCollection!: boolean;
    skipIfCollected!: boolean;

    constructor(data?: ICopyDeckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deckId = _data["deckId"];
            this.name = _data["name"];
            this.visibility = _data["visibility"];
            this.group = _data["group"];
            this.color = _data["color"];
            this.addToCollection = _data["addToCollection"];
            this.skipIfCollected = _data["skipIfCollected"];
        }
    }

    static fromJS(data: any): CopyDeckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDeckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deckId"] = this.deckId;
        data["name"] = this.name;
        data["visibility"] = this.visibility;
        data["group"] = this.group;
        data["color"] = this.color;
        data["addToCollection"] = this.addToCollection;
        data["skipIfCollected"] = this.skipIfCollected;
        return data;
    }
}

export interface ICopyDeckRequest {
    deckId: string;
    name: string | undefined;
    visibility: VisibilityType;
    group: string | undefined;
    color: string | undefined;
    addToCollection: boolean;
    skipIfCollected: boolean;
}

export class CreateDeckRequest implements ICreateDeckRequest {
    name!: string | undefined;
    game!: GameType;
    type!: string | undefined;
    visibility!: VisibilityType;
    group!: string | undefined;
    color!: string | undefined;

    constructor(data?: ICreateDeckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.game = _data["game"];
            this.type = _data["type"];
            this.visibility = _data["visibility"];
            this.group = _data["group"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): CreateDeckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["game"] = this.game;
        data["type"] = this.type;
        data["visibility"] = this.visibility;
        data["group"] = this.group;
        data["color"] = this.color;
        return data;
    }
}

export interface ICreateDeckRequest {
    name: string | undefined;
    game: GameType;
    type: string | undefined;
    visibility: VisibilityType;
    group: string | undefined;
    color: string | undefined;
}

export class CreateDeckResponse implements ICreateDeckResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    deckId?: string | undefined;
    owner?: string | undefined;

    constructor(data?: ICreateDeckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.deckId = _data["deckId"];
            this.owner = _data["owner"];
        }
    }

    static fromJS(data: any): CreateDeckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["deckId"] = this.deckId;
        data["owner"] = this.owner;
        return data;
    }
}

export interface ICreateDeckResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    deckId?: string | undefined;
    owner?: string | undefined;
}

export class CreateGlobalNotificationRequest implements ICreateGlobalNotificationRequest {
    message!: string | undefined;
    linkedPostId?: string | undefined;
    startUtc?: Date | undefined;
    endUtc?: Date | undefined;

    constructor(data?: ICreateGlobalNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.linkedPostId = _data["linkedPostId"];
            this.startUtc = _data["startUtc"] ? new Date(_data["startUtc"].toString()) : <any>undefined;
            this.endUtc = _data["endUtc"] ? new Date(_data["endUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateGlobalNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGlobalNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["linkedPostId"] = this.linkedPostId;
        data["startUtc"] = this.startUtc ? this.startUtc.toISOString() : <any>undefined;
        data["endUtc"] = this.endUtc ? this.endUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateGlobalNotificationRequest {
    message: string | undefined;
    linkedPostId?: string | undefined;
    startUtc?: Date | undefined;
    endUtc?: Date | undefined;
}

export class CreateMagicSetRequest implements ICreateMagicSetRequest {
    name!: string | undefined;
    code!: string | undefined;
    releaseDate!: Date;
    setType!: MagicSetType;
    parentSetId?: string | undefined;
    parentBlockId?: string | undefined;
    universesBeyond?: boolean;

    constructor(data?: ICreateMagicSetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            this.setType = _data["setType"];
            this.parentSetId = _data["parentSetId"];
            this.parentBlockId = _data["parentBlockId"];
            this.universesBeyond = _data["universesBeyond"];
        }
    }

    static fromJS(data: any): CreateMagicSetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMagicSetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["releaseDate"] = this.releaseDate ? formatDate(this.releaseDate) : <any>undefined;
        data["setType"] = this.setType;
        data["parentSetId"] = this.parentSetId;
        data["parentBlockId"] = this.parentBlockId;
        data["universesBeyond"] = this.universesBeyond;
        return data;
    }
}

export interface ICreateMagicSetRequest {
    name: string | undefined;
    code: string | undefined;
    releaseDate: Date;
    setType: MagicSetType;
    parentSetId?: string | undefined;
    parentBlockId?: string | undefined;
    universesBeyond?: boolean;
}

export class CreateMagicSetResponse implements ICreateMagicSetResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    newSet?: MagicSet;

    constructor(data?: ICreateMagicSetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.newSet = _data["newSet"] ? MagicSet.fromJS(_data["newSet"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMagicSetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMagicSetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["newSet"] = this.newSet ? this.newSet.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateMagicSetResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    newSet?: MagicSet;
}

export class CreateNewsPostRequest implements ICreateNewsPostRequest {
    title!: string | undefined;
    content!: string | undefined;

    constructor(data?: ICreateNewsPostRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CreateNewsPostRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewsPostRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        return data;
    }
}

export interface ICreateNewsPostRequest {
    title: string | undefined;
    content: string | undefined;
}

export class CreateNewsPostResponse implements ICreateNewsPostResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    post?: NewsPost;

    constructor(data?: ICreateNewsPostResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.post = _data["post"] ? NewsPost.fromJS(_data["post"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateNewsPostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewsPostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["post"] = this.post ? this.post.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateNewsPostResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    post?: NewsPost;
}

export class CreateNotificationResponse implements ICreateNotificationResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    notificationId?: string | undefined;

    constructor(data?: ICreateNotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.notificationId = _data["notificationId"];
        }
    }

    static fromJS(data: any): CreateNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["notificationId"] = this.notificationId;
        return data;
    }
}

export interface ICreateNotificationResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    notificationId?: string | undefined;
}

export class DataPerformance implements IDataPerformance {
    fetchMs?: number;
    composeMs?: number;

    constructor(data?: IDataPerformance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fetchMs = _data["fetchMs"];
            this.composeMs = _data["composeMs"];
        }
    }

    static fromJS(data: any): DataPerformance {
        data = typeof data === 'object' ? data : {};
        let result = new DataPerformance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fetchMs"] = this.fetchMs;
        data["composeMs"] = this.composeMs;
        return data;
    }
}

export interface IDataPerformance {
    fetchMs?: number;
    composeMs?: number;
}

export class DataResponse implements IDataResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;

    constructor(data?: IDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDataResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
}

export class Deck implements IDeck {
    id!: string;
    owner!: string | undefined;
    ownerId!: string;
    name!: string | undefined;
    createdAt!: Date;
    updatedAt?: Date | undefined;
    visibility!: VisibilityType;
    game!: GameType;
    type!: string | undefined;
    group?: string | undefined;
    backgroundCardId?: string | undefined;
    color!: string | undefined;
    count!: number;
    isFavorited?: boolean | undefined;
    layers!: DeckLayer[] | undefined;

    constructor(data?: IDeck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.owner = _data["owner"];
            this.ownerId = _data["ownerId"];
            this.name = _data["name"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.visibility = _data["visibility"];
            this.game = _data["game"];
            this.type = _data["type"];
            this.group = _data["group"];
            this.backgroundCardId = _data["backgroundCardId"];
            this.color = _data["color"];
            this.count = _data["count"];
            this.isFavorited = _data["isFavorited"];
            if (Array.isArray(_data["layers"])) {
                this.layers = [] as any;
                for (let item of _data["layers"])
                    this.layers!.push(DeckLayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Deck {
        data = typeof data === 'object' ? data : {};
        let result = new Deck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["owner"] = this.owner;
        data["ownerId"] = this.ownerId;
        data["name"] = this.name;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["visibility"] = this.visibility;
        data["game"] = this.game;
        data["type"] = this.type;
        data["group"] = this.group;
        data["backgroundCardId"] = this.backgroundCardId;
        data["color"] = this.color;
        data["count"] = this.count;
        data["isFavorited"] = this.isFavorited;
        if (Array.isArray(this.layers)) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeck {
    id: string;
    owner: string | undefined;
    ownerId: string;
    name: string | undefined;
    createdAt: Date;
    updatedAt?: Date | undefined;
    visibility: VisibilityType;
    game: GameType;
    type: string | undefined;
    group?: string | undefined;
    backgroundCardId?: string | undefined;
    color: string | undefined;
    count: number;
    isFavorited?: boolean | undefined;
    layers: DeckLayer[] | undefined;
}

export class DeckCard implements IDeckCard {
    deckCardId!: string;
    card!: CollectedPreviewItem;
    count!: number;
    specialCount!: number;
    tag!: DeckCardTagType;
    color?: string | undefined;

    constructor(data?: IDeckCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.card = new CollectedPreviewItem();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deckCardId = _data["deckCardId"];
            this.card = _data["card"] ? CollectedPreviewItem.fromJS(_data["card"]) : new CollectedPreviewItem();
            this.count = _data["count"];
            this.specialCount = _data["specialCount"];
            this.tag = _data["tag"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): DeckCard {
        data = typeof data === 'object' ? data : {};
        let result = new DeckCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deckCardId"] = this.deckCardId;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["count"] = this.count;
        data["specialCount"] = this.specialCount;
        data["tag"] = this.tag;
        data["color"] = this.color;
        return data;
    }
}

export interface IDeckCard {
    deckCardId: string;
    card: CollectedPreviewItem;
    count: number;
    specialCount: number;
    tag: DeckCardTagType;
    color?: string | undefined;
}

export class DeckCardAddition implements IDeckCardAddition {
    cardId!: string;
    count!: number;
    specialCount!: number;
    layer!: string | undefined;

    constructor(data?: IDeckCardAddition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.count = _data["count"];
            this.specialCount = _data["specialCount"];
            this.layer = _data["layer"];
        }
    }

    static fromJS(data: any): DeckCardAddition {
        data = typeof data === 'object' ? data : {};
        let result = new DeckCardAddition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["count"] = this.count;
        data["specialCount"] = this.specialCount;
        data["layer"] = this.layer;
        return data;
    }
}

export interface IDeckCardAddition {
    cardId: string;
    count: number;
    specialCount: number;
    layer: string | undefined;
}

export class DeckCardAdditionResult implements IDeckCardAdditionResult {
    cardId!: string;
    count!: number;
    specialCount!: number;
    layer!: string | undefined;
    deckCard!: DeckCard;

    constructor(data?: IDeckCardAdditionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.deckCard = new DeckCard();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.count = _data["count"];
            this.specialCount = _data["specialCount"];
            this.layer = _data["layer"];
            this.deckCard = _data["deckCard"] ? DeckCard.fromJS(_data["deckCard"]) : new DeckCard();
        }
    }

    static fromJS(data: any): DeckCardAdditionResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeckCardAdditionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["count"] = this.count;
        data["specialCount"] = this.specialCount;
        data["layer"] = this.layer;
        data["deckCard"] = this.deckCard ? this.deckCard.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeckCardAdditionResult {
    cardId: string;
    count: number;
    specialCount: number;
    layer: string | undefined;
    deckCard: DeckCard;
}

export class DeckCardChanges implements IDeckCardChanges {
    cardId!: string;
    tag?: DeckCardTagType;
    count?: number | undefined;
    specialCount?: number | undefined;
    layer?: string | undefined;
    altVersion?: string | undefined;
    color?: string | undefined;

    constructor(data?: IDeckCardChanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.tag = _data["tag"];
            this.count = _data["count"];
            this.specialCount = _data["specialCount"];
            this.layer = _data["layer"];
            this.altVersion = _data["altVersion"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): DeckCardChanges {
        data = typeof data === 'object' ? data : {};
        let result = new DeckCardChanges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["tag"] = this.tag;
        data["count"] = this.count;
        data["specialCount"] = this.specialCount;
        data["layer"] = this.layer;
        data["altVersion"] = this.altVersion;
        data["color"] = this.color;
        return data;
    }
}

export interface IDeckCardChanges {
    cardId: string;
    tag?: DeckCardTagType;
    count?: number | undefined;
    specialCount?: number | undefined;
    layer?: string | undefined;
    altVersion?: string | undefined;
    color?: string | undefined;
}

export class DeckCardCount implements IDeckCardCount {
    deckId!: string;
    deckName!: string | undefined;
    deckColor!: string | undefined;
    isFavorited!: boolean;
    backgroundCardId?: string | undefined;
    mainboardDeckCardId?: string | undefined;
    mainboardCount?: number;
    mainboardSpecialCount?: number;
    sideboardDeckCardId?: string | undefined;
    sideboardCount?: number;
    sideboardSpecialCount?: number;
    maybeboardDeckCardId?: string | undefined;
    maybeboardCount?: number;
    maybeboardSpecialCount?: number;
    planningDeckCardId?: string | undefined;
    planningCount?: number;
    planningSpecialCount?: number;

    constructor(data?: IDeckCardCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deckId = _data["deckId"];
            this.deckName = _data["deckName"];
            this.deckColor = _data["deckColor"];
            this.isFavorited = _data["isFavorited"];
            this.backgroundCardId = _data["backgroundCardId"];
            this.mainboardDeckCardId = _data["mainboardDeckCardId"];
            this.mainboardCount = _data["mainboardCount"];
            this.mainboardSpecialCount = _data["mainboardSpecialCount"];
            this.sideboardDeckCardId = _data["sideboardDeckCardId"];
            this.sideboardCount = _data["sideboardCount"];
            this.sideboardSpecialCount = _data["sideboardSpecialCount"];
            this.maybeboardDeckCardId = _data["maybeboardDeckCardId"];
            this.maybeboardCount = _data["maybeboardCount"];
            this.maybeboardSpecialCount = _data["maybeboardSpecialCount"];
            this.planningDeckCardId = _data["planningDeckCardId"];
            this.planningCount = _data["planningCount"];
            this.planningSpecialCount = _data["planningSpecialCount"];
        }
    }

    static fromJS(data: any): DeckCardCount {
        data = typeof data === 'object' ? data : {};
        let result = new DeckCardCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deckId"] = this.deckId;
        data["deckName"] = this.deckName;
        data["deckColor"] = this.deckColor;
        data["isFavorited"] = this.isFavorited;
        data["backgroundCardId"] = this.backgroundCardId;
        data["mainboardDeckCardId"] = this.mainboardDeckCardId;
        data["mainboardCount"] = this.mainboardCount;
        data["mainboardSpecialCount"] = this.mainboardSpecialCount;
        data["sideboardDeckCardId"] = this.sideboardDeckCardId;
        data["sideboardCount"] = this.sideboardCount;
        data["sideboardSpecialCount"] = this.sideboardSpecialCount;
        data["maybeboardDeckCardId"] = this.maybeboardDeckCardId;
        data["maybeboardCount"] = this.maybeboardCount;
        data["maybeboardSpecialCount"] = this.maybeboardSpecialCount;
        data["planningDeckCardId"] = this.planningDeckCardId;
        data["planningCount"] = this.planningCount;
        data["planningSpecialCount"] = this.planningSpecialCount;
        return data;
    }
}

export interface IDeckCardCount {
    deckId: string;
    deckName: string | undefined;
    deckColor: string | undefined;
    isFavorited: boolean;
    backgroundCardId?: string | undefined;
    mainboardDeckCardId?: string | undefined;
    mainboardCount?: number;
    mainboardSpecialCount?: number;
    sideboardDeckCardId?: string | undefined;
    sideboardCount?: number;
    sideboardSpecialCount?: number;
    maybeboardDeckCardId?: string | undefined;
    maybeboardCount?: number;
    maybeboardSpecialCount?: number;
    planningDeckCardId?: string | undefined;
    planningCount?: number;
    planningSpecialCount?: number;
}

export enum DeckCardTagType {
    None = "None",
    Commander = "Commander",
    Oathbreaker = "Oathbreaker",
    SignatureSpell = "SignatureSpell",
}

export class DeckChanges implements IDeckChanges {
    name?: string | undefined;
    color?: string | undefined;
    backgroundCardId?: string | undefined;
    visibility?: VisibilityType;
    type?: string | undefined;
    group?: string | undefined;
    isFavorited?: boolean | undefined;

    constructor(data?: IDeckChanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.color = _data["color"];
            this.backgroundCardId = _data["backgroundCardId"];
            this.visibility = _data["visibility"];
            this.type = _data["type"];
            this.group = _data["group"];
            this.isFavorited = _data["isFavorited"];
        }
    }

    static fromJS(data: any): DeckChanges {
        data = typeof data === 'object' ? data : {};
        let result = new DeckChanges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["color"] = this.color;
        data["backgroundCardId"] = this.backgroundCardId;
        data["visibility"] = this.visibility;
        data["type"] = this.type;
        data["group"] = this.group;
        data["isFavorited"] = this.isFavorited;
        return data;
    }
}

export interface IDeckChanges {
    name?: string | undefined;
    color?: string | undefined;
    backgroundCardId?: string | undefined;
    visibility?: VisibilityType;
    type?: string | undefined;
    group?: string | undefined;
    isFavorited?: boolean | undefined;
}

export enum DeckFileFormat {
    Unknown = "Unknown",
    Wizards = "Wizards",
    Moxfield = "Moxfield",
    MtgWtf = "MtgWtf",
}

export class DeckLayer implements IDeckLayer {
    name!: string | undefined;
    distinctCount!: number;
    totalCount!: number;
    cards!: DeckCard[] | undefined;

    constructor(data?: IDeckLayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.distinctCount = _data["distinctCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(DeckCard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeckLayer {
        data = typeof data === 'object' ? data : {};
        let result = new DeckLayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["distinctCount"] = this.distinctCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeckLayer {
    name: string | undefined;
    distinctCount: number;
    totalCount: number;
    cards: DeckCard[] | undefined;
}

export enum GameType {
    None = "None",
    Magic = "Magic",
    Pokemon = "Pokemon",
    Yugioh = "Yugioh",
    Lorcana = "Lorcana",
}

export class GetCollectionPreviewResponse implements IGetCollectionPreviewResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;
    collections?: CollectionPreview[] | undefined;

    constructor(data?: IGetCollectionPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["collections"])) {
                this.collections = [] as any;
                for (let item of _data["collections"])
                    this.collections!.push(CollectionPreview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCollectionPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollectionPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.collections)) {
            data["collections"] = [];
            for (let item of this.collections)
                data["collections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCollectionPreviewResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
    collections?: CollectionPreview[] | undefined;
}

export class GetCollectionResponse implements IGetCollectionResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;
    collection?: Collection;

    constructor(data?: IGetCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
            this.collection = _data["collection"] ? Collection.fromJS(_data["collection"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        data["collection"] = this.collection ? this.collection.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCollectionResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
    collection?: Collection;
}

export class GetCollectionSnapshotResponse implements IGetCollectionSnapshotResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;
    games?: CollectionSnapshotGameGroup[] | undefined;

    constructor(data?: IGetCollectionSnapshotResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["games"])) {
                this.games = [] as any;
                for (let item of _data["games"])
                    this.games!.push(CollectionSnapshotGameGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCollectionSnapshotResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollectionSnapshotResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.games)) {
            data["games"] = [];
            for (let item of this.games)
                data["games"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCollectionSnapshotResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
    games?: CollectionSnapshotGameGroup[] | undefined;
}

export class GetCollectionValueResponse implements IGetCollectionValueResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;
    game?: number | undefined;
    itemType?: ItemType;
    count?: number | undefined;
    value?: number | undefined;

    constructor(data?: IGetCollectionValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
            this.game = _data["game"];
            this.itemType = _data["itemType"];
            this.count = _data["count"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetCollectionValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCollectionValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        data["game"] = this.game;
        data["itemType"] = this.itemType;
        data["count"] = this.count;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetCollectionValueResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
    game?: number | undefined;
    itemType?: ItemType;
    count?: number | undefined;
    value?: number | undefined;
}

export class GetDeckCardCountsResponse implements IGetDeckCardCountsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    decks?: DeckCardCount[] | undefined;

    constructor(data?: IGetDeckCardCountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["decks"])) {
                this.decks = [] as any;
                for (let item of _data["decks"])
                    this.decks!.push(DeckCardCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeckCardCountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeckCardCountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.decks)) {
            data["decks"] = [];
            for (let item of this.decks)
                data["decks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDeckCardCountsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    decks?: DeckCardCount[] | undefined;
}

export class GetDeckResponse implements IGetDeckResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;
    deck?: Deck;

    constructor(data?: IGetDeckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
            this.deck = _data["deck"] ? Deck.fromJS(_data["deck"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        data["deck"] = this.deck ? this.deck.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDeckResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
    deck?: Deck;
}

export class GetDecksResponse implements IGetDecksResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;
    decks?: Deck[] | undefined;

    constructor(data?: IGetDecksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["decks"])) {
                this.decks = [] as any;
                for (let item of _data["decks"])
                    this.decks!.push(Deck.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDecksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDecksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.decks)) {
            data["decks"] = [];
            for (let item of this.decks)
                data["decks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDecksResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
    decks?: Deck[] | undefined;
}

export class GetDecksWithCardResponse implements IGetDecksWithCardResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    cards?: CardInDeck[] | undefined;

    constructor(data?: IGetDecksWithCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CardInDeck.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDecksWithCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDecksWithCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDecksWithCardResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    cards?: CardInDeck[] | undefined;
}

export class GetFeaturedCardsResponse implements IGetFeaturedCardsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    cards?: CollectedPreviewItem[] | undefined;

    constructor(data?: IGetFeaturedCardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CollectedPreviewItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFeaturedCardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeaturedCardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFeaturedCardsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    cards?: CollectedPreviewItem[] | undefined;
}

export class GetItemRouteResponse implements IGetItemRouteResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    url?: string | undefined;

    constructor(data?: IGetItemRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetItemRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetItemRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["url"] = this.url;
        return data;
    }
}

export interface IGetItemRouteResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    url?: string | undefined;
}

export class GetMagicBlockResponse implements IGetMagicBlockResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    block?: MagicBlock;
    children?: MagicSet[] | undefined;

    constructor(data?: IGetMagicBlockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.block = _data["block"] ? MagicBlock.fromJS(_data["block"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MagicSet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMagicBlockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagicBlockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["block"] = this.block ? this.block.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMagicBlockResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    block?: MagicBlock;
    children?: MagicSet[] | undefined;
}

export class GetMagicCardRequest implements IGetMagicCardRequest {
    preview?: boolean;
    nameProps?: ViaName;
    setProps?: ViaSet;
    collectionProps?: ViaCollection;

    constructor(data?: IGetMagicCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preview = _data["preview"];
            this.nameProps = _data["nameProps"] ? ViaName.fromJS(_data["nameProps"]) : <any>undefined;
            this.setProps = _data["setProps"] ? ViaSet.fromJS(_data["setProps"]) : <any>undefined;
            this.collectionProps = _data["collectionProps"] ? ViaCollection.fromJS(_data["collectionProps"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMagicCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagicCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preview"] = this.preview;
        data["nameProps"] = this.nameProps ? this.nameProps.toJSON() : <any>undefined;
        data["setProps"] = this.setProps ? this.setProps.toJSON() : <any>undefined;
        data["collectionProps"] = this.collectionProps ? this.collectionProps.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMagicCardRequest {
    preview?: boolean;
    nameProps?: ViaName;
    setProps?: ViaSet;
    collectionProps?: ViaCollection;
}

export class GetMagicCardResponse implements IGetMagicCardResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;
    count?: number;
    cards?: CollectedMagicCard[] | undefined;
    previews?: CollectedPreviewItem[] | undefined;

    constructor(data?: IGetMagicCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
            this.count = _data["count"];
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CollectedMagicCard.fromJS(item));
            }
            if (Array.isArray(_data["previews"])) {
                this.previews = [] as any;
                for (let item of _data["previews"])
                    this.previews!.push(CollectedPreviewItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMagicCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagicCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        data["count"] = this.count;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        if (Array.isArray(this.previews)) {
            data["previews"] = [];
            for (let item of this.previews)
                data["previews"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMagicCardResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
    count?: number;
    cards?: CollectedMagicCard[] | undefined;
    previews?: CollectedPreviewItem[] | undefined;
}

export class GetMagicCardRulingsResponse implements IGetMagicCardRulingsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    rulings?: MagicCardRuling[] | undefined;

    constructor(data?: IGetMagicCardRulingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["rulings"])) {
                this.rulings = [] as any;
                for (let item of _data["rulings"])
                    this.rulings!.push(MagicCardRuling.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMagicCardRulingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagicCardRulingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.rulings)) {
            data["rulings"] = [];
            for (let item of this.rulings)
                data["rulings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMagicCardRulingsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    rulings?: MagicCardRuling[] | undefined;
}

export class GetMagicCollectionCardsForStatsResponse implements IGetMagicCollectionCardsForStatsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;
    magicCards?: MagicCardForStats[] | undefined;
    magicSets?: MagicSetForStats[] | undefined;

    constructor(data?: IGetMagicCollectionCardsForStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["magicCards"])) {
                this.magicCards = [] as any;
                for (let item of _data["magicCards"])
                    this.magicCards!.push(MagicCardForStats.fromJS(item));
            }
            if (Array.isArray(_data["magicSets"])) {
                this.magicSets = [] as any;
                for (let item of _data["magicSets"])
                    this.magicSets!.push(MagicSetForStats.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMagicCollectionCardsForStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagicCollectionCardsForStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.magicCards)) {
            data["magicCards"] = [];
            for (let item of this.magicCards)
                data["magicCards"].push(item.toJSON());
        }
        if (Array.isArray(this.magicSets)) {
            data["magicSets"] = [];
            for (let item of this.magicSets)
                data["magicSets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMagicCollectionCardsForStatsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
    magicCards?: MagicCardForStats[] | undefined;
    magicSets?: MagicSetForStats[] | undefined;
}

export class GetMagicSetResponse implements IGetMagicSetResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    set?: MagicSet;
    children?: MagicSet[] | undefined;

    constructor(data?: IGetMagicSetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.set = _data["set"] ? MagicSet.fromJS(_data["set"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MagicSet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMagicSetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagicSetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["set"] = this.set ? this.set.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMagicSetResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    set?: MagicSet;
    children?: MagicSet[] | undefined;
}

export class GetMagicSetsResponse implements IGetMagicSetsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    sets?: MagicSet[] | undefined;

    constructor(data?: IGetMagicSetsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["sets"])) {
                this.sets = [] as any;
                for (let item of _data["sets"])
                    this.sets!.push(MagicSet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMagicSetsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMagicSetsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.sets)) {
            data["sets"] = [];
            for (let item of this.sets)
                data["sets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMagicSetsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    sets?: MagicSet[] | undefined;
}

export class GetNewsPostResponse implements IGetNewsPostResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    post?: NewsPost;

    constructor(data?: IGetNewsPostResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.post = _data["post"] ? NewsPost.fromJS(_data["post"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNewsPostResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsPostResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["post"] = this.post ? this.post.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNewsPostResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    post?: NewsPost;
}

export class GetNewsPostStubsResponse implements IGetNewsPostStubsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    posts?: NewsPostStub[] | undefined;

    constructor(data?: IGetNewsPostStubsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["posts"])) {
                this.posts = [] as any;
                for (let item of _data["posts"])
                    this.posts!.push(NewsPostStub.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNewsPostStubsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsPostStubsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.posts)) {
            data["posts"] = [];
            for (let item of this.posts)
                data["posts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNewsPostStubsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    posts?: NewsPostStub[] | undefined;
}

export class GetNewsPostsResponse implements IGetNewsPostsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    start?: number | undefined;
    count?: number | undefined;
    total?: number | undefined;
    posts?: NewsPost[] | undefined;

    constructor(data?: IGetNewsPostsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.start = _data["start"];
            this.count = _data["count"];
            this.total = _data["total"];
            if (Array.isArray(_data["posts"])) {
                this.posts = [] as any;
                for (let item of _data["posts"])
                    this.posts!.push(NewsPost.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNewsPostsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsPostsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["start"] = this.start;
        data["count"] = this.count;
        data["total"] = this.total;
        if (Array.isArray(this.posts)) {
            data["posts"] = [];
            for (let item of this.posts)
                data["posts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNewsPostsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    start?: number | undefined;
    count?: number | undefined;
    total?: number | undefined;
    posts?: NewsPost[] | undefined;
}

export class GetNotificationsResponse implements IGetNotificationsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    notifications?: Notification[] | undefined;

    constructor(data?: IGetNotificationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(Notification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    notifications?: Notification[] | undefined;
}

export class GetPresignedUrlResponse implements IGetPresignedUrlResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    presignedUrl?: string | undefined;
    objectKey?: string | undefined;

    constructor(data?: IGetPresignedUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.presignedUrl = _data["presignedUrl"];
            this.objectKey = _data["objectKey"];
        }
    }

    static fromJS(data: any): GetPresignedUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPresignedUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["presignedUrl"] = this.presignedUrl;
        data["objectKey"] = this.objectKey;
        return data;
    }
}

export interface IGetPresignedUrlResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    presignedUrl?: string | undefined;
    objectKey?: string | undefined;
}

export class GetUserCollectionActionsResponse implements IGetUserCollectionActionsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    total?: number | undefined;
    start?: number | undefined;
    count?: number | undefined;
    actions?: UserCollectionAction[] | undefined;

    constructor(data?: IGetUserCollectionActionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.total = _data["total"];
            this.start = _data["start"];
            this.count = _data["count"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(UserCollectionAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserCollectionActionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserCollectionActionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["total"] = this.total;
        data["start"] = this.start;
        data["count"] = this.count;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserCollectionActionsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    total?: number | undefined;
    start?: number | undefined;
    count?: number | undefined;
    actions?: UserCollectionAction[] | undefined;
}

export class GetUserPrivacySettingsResponse implements IGetUserPrivacySettingsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    settings?: UserPrivacySettings;

    constructor(data?: IGetUserPrivacySettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.settings = _data["settings"] ? UserPrivacySettings.fromJS(_data["settings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserPrivacySettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPrivacySettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserPrivacySettingsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    settings?: UserPrivacySettings;
}

export class GetUserProfileResponse implements IGetUserProfileResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;
    userProfile?: UserAndProfile;
    relationship?: UserRelationship;

    constructor(data?: IGetUserProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
            this.userProfile = _data["userProfile"] ? UserAndProfile.fromJS(_data["userProfile"]) : <any>undefined;
            this.relationship = _data["relationship"] ? UserRelationship.fromJS(_data["relationship"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : <any>undefined;
        data["relationship"] = this.relationship ? this.relationship.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserProfileResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
    userProfile?: UserAndProfile;
    relationship?: UserRelationship;
}

export class GetUserRelationshipsResponse implements IGetUserRelationshipsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    relationships?: UserRelationship[] | undefined;

    constructor(data?: IGetUserRelationshipsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["relationships"])) {
                this.relationships = [] as any;
                for (let item of _data["relationships"])
                    this.relationships!.push(UserRelationship.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserRelationshipsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRelationshipsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.relationships)) {
            data["relationships"] = [];
            for (let item of this.relationships)
                data["relationships"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserRelationshipsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    relationships?: UserRelationship[] | undefined;
}

export class GetUserResourceVisibilityResponse implements IGetUserResourceVisibilityResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible!: boolean;

    constructor(data?: IGetUserResourceVisibilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): GetUserResourceVisibilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserResourceVisibilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IGetUserResourceVisibilityResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    isVisible: boolean;
}

export class ImportDeckRequest implements IImportDeckRequest {
    name!: string | undefined;
    game!: GameType;
    type!: string | undefined;
    visibility!: VisibilityType;
    group!: string | undefined;
    color!: string | undefined;
    addToCollection!: boolean;
    skipIfCollected!: boolean;
    format!: DeckFileFormat;
    contents?: string | undefined;
    sourceUrl?: string | undefined;

    constructor(data?: IImportDeckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.game = _data["game"];
            this.type = _data["type"];
            this.visibility = _data["visibility"];
            this.group = _data["group"];
            this.color = _data["color"];
            this.addToCollection = _data["addToCollection"];
            this.skipIfCollected = _data["skipIfCollected"];
            this.format = _data["format"];
            this.contents = _data["contents"];
            this.sourceUrl = _data["sourceUrl"];
        }
    }

    static fromJS(data: any): ImportDeckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDeckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["game"] = this.game;
        data["type"] = this.type;
        data["visibility"] = this.visibility;
        data["group"] = this.group;
        data["color"] = this.color;
        data["addToCollection"] = this.addToCollection;
        data["skipIfCollected"] = this.skipIfCollected;
        data["format"] = this.format;
        data["contents"] = this.contents;
        data["sourceUrl"] = this.sourceUrl;
        return data;
    }
}

export interface IImportDeckRequest {
    name: string | undefined;
    game: GameType;
    type: string | undefined;
    visibility: VisibilityType;
    group: string | undefined;
    color: string | undefined;
    addToCollection: boolean;
    skipIfCollected: boolean;
    format: DeckFileFormat;
    contents?: string | undefined;
    sourceUrl?: string | undefined;
}

export class ImportPreconDeckRequest implements IImportPreconDeckRequest {
    name!: string | undefined;
    game!: GameType;
    type!: string | undefined;
    visibility!: VisibilityType;
    group!: string | undefined;
    color!: string | undefined;
    addToCollection!: boolean;
    skipIfCollected!: boolean;
    format!: DeckFileFormat;
    contents?: string | undefined;
    sourceUrl?: string | undefined;
    createDateOverride?: Date | undefined;

    constructor(data?: IImportPreconDeckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.game = _data["game"];
            this.type = _data["type"];
            this.visibility = _data["visibility"];
            this.group = _data["group"];
            this.color = _data["color"];
            this.addToCollection = _data["addToCollection"];
            this.skipIfCollected = _data["skipIfCollected"];
            this.format = _data["format"];
            this.contents = _data["contents"];
            this.sourceUrl = _data["sourceUrl"];
            this.createDateOverride = _data["createDateOverride"] ? new Date(_data["createDateOverride"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImportPreconDeckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportPreconDeckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["game"] = this.game;
        data["type"] = this.type;
        data["visibility"] = this.visibility;
        data["group"] = this.group;
        data["color"] = this.color;
        data["addToCollection"] = this.addToCollection;
        data["skipIfCollected"] = this.skipIfCollected;
        data["format"] = this.format;
        data["contents"] = this.contents;
        data["sourceUrl"] = this.sourceUrl;
        data["createDateOverride"] = this.createDateOverride ? formatDate(this.createDateOverride) : <any>undefined;
        return data;
    }
}

export interface IImportPreconDeckRequest {
    name: string | undefined;
    game: GameType;
    type: string | undefined;
    visibility: VisibilityType;
    group: string | undefined;
    color: string | undefined;
    addToCollection: boolean;
    skipIfCollected: boolean;
    format: DeckFileFormat;
    contents?: string | undefined;
    sourceUrl?: string | undefined;
    createDateOverride?: Date | undefined;
}

export class ItemSearch implements IItemSearch {
    name!: string | undefined;
    exact?: boolean;
    distinct?: boolean;
    useSetPriority?: boolean;
    sortAlphabetical?: boolean;
    sortCollectedCount?: boolean;

    constructor(data?: IItemSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.exact = _data["exact"];
            this.distinct = _data["distinct"];
            this.useSetPriority = _data["useSetPriority"];
            this.sortAlphabetical = _data["sortAlphabetical"];
            this.sortCollectedCount = _data["sortCollectedCount"];
        }
    }

    static fromJS(data: any): ItemSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["exact"] = this.exact;
        data["distinct"] = this.distinct;
        data["useSetPriority"] = this.useSetPriority;
        data["sortAlphabetical"] = this.sortAlphabetical;
        data["sortCollectedCount"] = this.sortCollectedCount;
        return data;
    }
}

export interface IItemSearch {
    name: string | undefined;
    exact?: boolean;
    distinct?: boolean;
    useSetPriority?: boolean;
    sortAlphabetical?: boolean;
    sortCollectedCount?: boolean;
}

export enum ItemType {
    None = "None",
    Card = "Card",
    Sealed = "Sealed",
}

export enum LayoutType {
    Normal = "Normal",
    Split = "Split",
    Flip = "Flip",
    Transform = "Transform",
    ModalDfc = "ModalDfc",
    Meld = "Meld",
    Leveler = "Leveler",
    Class = "Class",
    Case = "Case",
    Saga = "Saga",
    Adventure = "Adventure",
    Mutate = "Mutate",
    Prototype = "Prototype",
    Battle = "Battle",
    Planar = "Planar",
    Scheme = "Scheme",
    Vanguard = "Vanguard",
    Token = "Token",
    DoubleFacedToken = "DoubleFacedToken",
    Emblem = "Emblem",
    Augment = "Augment",
    Host = "Host",
    ArtSeries = "ArtSeries",
    ReversibleCard = "ReversibleCard",
}

export class MagicAdvancedSearchParameters implements IMagicAdvancedSearchParameters {
    name?: string | undefined;
    rulesText?: string | undefined;
    rulesTextRegex?: string | undefined;
    flavorText?: string | undefined;
    colorCost?: ColorParameter;
    colorProduction?: ColorParameter;
    manaCost?: RangeParameter;
    cardSupertypes?: ArrayParameter;
    cardTypes?: ArrayParameter;
    cardSubtypes?: ArrayParameter;
    rarities?: ArrayParameter;
    power?: RangeParameter;
    toughness?: RangeParameter;
    releaseSets?: ArrayParameter;
    releaseYear?: RangeParameter;
    artists?: ArrayParameter;
    treatments?: ArrayParameter;
    value?: RangeParameter;
    legalities?: ArrayParameter;

    constructor(data?: IMagicAdvancedSearchParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rulesText = _data["rulesText"];
            this.rulesTextRegex = _data["rulesTextRegex"];
            this.flavorText = _data["flavorText"];
            this.colorCost = _data["colorCost"] ? ColorParameter.fromJS(_data["colorCost"]) : <any>undefined;
            this.colorProduction = _data["colorProduction"] ? ColorParameter.fromJS(_data["colorProduction"]) : <any>undefined;
            this.manaCost = _data["manaCost"] ? RangeParameter.fromJS(_data["manaCost"]) : <any>undefined;
            this.cardSupertypes = _data["cardSupertypes"] ? ArrayParameter.fromJS(_data["cardSupertypes"]) : <any>undefined;
            this.cardTypes = _data["cardTypes"] ? ArrayParameter.fromJS(_data["cardTypes"]) : <any>undefined;
            this.cardSubtypes = _data["cardSubtypes"] ? ArrayParameter.fromJS(_data["cardSubtypes"]) : <any>undefined;
            this.rarities = _data["rarities"] ? ArrayParameter.fromJS(_data["rarities"]) : <any>undefined;
            this.power = _data["power"] ? RangeParameter.fromJS(_data["power"]) : <any>undefined;
            this.toughness = _data["toughness"] ? RangeParameter.fromJS(_data["toughness"]) : <any>undefined;
            this.releaseSets = _data["releaseSets"] ? ArrayParameter.fromJS(_data["releaseSets"]) : <any>undefined;
            this.releaseYear = _data["releaseYear"] ? RangeParameter.fromJS(_data["releaseYear"]) : <any>undefined;
            this.artists = _data["artists"] ? ArrayParameter.fromJS(_data["artists"]) : <any>undefined;
            this.treatments = _data["treatments"] ? ArrayParameter.fromJS(_data["treatments"]) : <any>undefined;
            this.value = _data["value"] ? RangeParameter.fromJS(_data["value"]) : <any>undefined;
            this.legalities = _data["legalities"] ? ArrayParameter.fromJS(_data["legalities"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MagicAdvancedSearchParameters {
        data = typeof data === 'object' ? data : {};
        let result = new MagicAdvancedSearchParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rulesText"] = this.rulesText;
        data["rulesTextRegex"] = this.rulesTextRegex;
        data["flavorText"] = this.flavorText;
        data["colorCost"] = this.colorCost ? this.colorCost.toJSON() : <any>undefined;
        data["colorProduction"] = this.colorProduction ? this.colorProduction.toJSON() : <any>undefined;
        data["manaCost"] = this.manaCost ? this.manaCost.toJSON() : <any>undefined;
        data["cardSupertypes"] = this.cardSupertypes ? this.cardSupertypes.toJSON() : <any>undefined;
        data["cardTypes"] = this.cardTypes ? this.cardTypes.toJSON() : <any>undefined;
        data["cardSubtypes"] = this.cardSubtypes ? this.cardSubtypes.toJSON() : <any>undefined;
        data["rarities"] = this.rarities ? this.rarities.toJSON() : <any>undefined;
        data["power"] = this.power ? this.power.toJSON() : <any>undefined;
        data["toughness"] = this.toughness ? this.toughness.toJSON() : <any>undefined;
        data["releaseSets"] = this.releaseSets ? this.releaseSets.toJSON() : <any>undefined;
        data["releaseYear"] = this.releaseYear ? this.releaseYear.toJSON() : <any>undefined;
        data["artists"] = this.artists ? this.artists.toJSON() : <any>undefined;
        data["treatments"] = this.treatments ? this.treatments.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["legalities"] = this.legalities ? this.legalities.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMagicAdvancedSearchParameters {
    name?: string | undefined;
    rulesText?: string | undefined;
    rulesTextRegex?: string | undefined;
    flavorText?: string | undefined;
    colorCost?: ColorParameter;
    colorProduction?: ColorParameter;
    manaCost?: RangeParameter;
    cardSupertypes?: ArrayParameter;
    cardTypes?: ArrayParameter;
    cardSubtypes?: ArrayParameter;
    rarities?: ArrayParameter;
    power?: RangeParameter;
    toughness?: RangeParameter;
    releaseSets?: ArrayParameter;
    releaseYear?: RangeParameter;
    artists?: ArrayParameter;
    treatments?: ArrayParameter;
    value?: RangeParameter;
    legalities?: ArrayParameter;
}

export class MagicBlock implements IMagicBlock {
    id!: string;
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IMagicBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MagicBlock {
        data = typeof data === 'object' ? data : {};
        let result = new MagicBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IMagicBlock {
    id: string;
    code: string | undefined;
    name: string | undefined;
}

export class MagicCard implements IMagicCard {
    id?: string;
    name?: string | undefined;
    altName?: string | undefined;
    game?: GameType;
    itemType?: ItemType;
    oracleId?: string;
    mvId?: number;
    scryfallId?: string | undefined;
    tcgplayerId?: number | undefined;
    setIndex!: string | undefined;
    set!: MagicSet;
    rarity!: RarityType;
    releaseDate?: Date;
    layout?: LayoutType;
    manaValue?: number;
    colorMask!: number;
    manaMask?: number | undefined;
    faces?: MagicCardFace[] | undefined;
    treatment!: MagicCardTreatment;
    legality!: number;

    constructor(data?: IMagicCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.set = new MagicSet();
            this.treatment = new MagicCardTreatment();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.altName = _data["altName"];
            this.game = _data["game"];
            this.itemType = _data["itemType"];
            this.oracleId = _data["oracleId"];
            this.mvId = _data["mvId"];
            this.scryfallId = _data["scryfallId"];
            this.tcgplayerId = _data["tcgplayerId"];
            this.setIndex = _data["setIndex"];
            this.set = _data["set"] ? MagicSet.fromJS(_data["set"]) : new MagicSet();
            this.rarity = _data["rarity"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            this.layout = _data["layout"];
            this.manaValue = _data["manaValue"];
            this.colorMask = _data["colorMask"];
            this.manaMask = _data["manaMask"];
            if (Array.isArray(_data["faces"])) {
                this.faces = [] as any;
                for (let item of _data["faces"])
                    this.faces!.push(MagicCardFace.fromJS(item));
            }
            this.treatment = _data["treatment"] ? MagicCardTreatment.fromJS(_data["treatment"]) : new MagicCardTreatment();
            this.legality = _data["legality"];
        }
    }

    static fromJS(data: any): MagicCard {
        data = typeof data === 'object' ? data : {};
        let result = new MagicCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["altName"] = this.altName;
        data["game"] = this.game;
        data["itemType"] = this.itemType;
        data["oracleId"] = this.oracleId;
        data["mvId"] = this.mvId;
        data["scryfallId"] = this.scryfallId;
        data["tcgplayerId"] = this.tcgplayerId;
        data["setIndex"] = this.setIndex;
        data["set"] = this.set ? this.set.toJSON() : <any>undefined;
        data["rarity"] = this.rarity;
        data["releaseDate"] = this.releaseDate ? formatDate(this.releaseDate) : <any>undefined;
        data["layout"] = this.layout;
        data["manaValue"] = this.manaValue;
        data["colorMask"] = this.colorMask;
        data["manaMask"] = this.manaMask;
        if (Array.isArray(this.faces)) {
            data["faces"] = [];
            for (let item of this.faces)
                data["faces"].push(item.toJSON());
        }
        data["treatment"] = this.treatment ? this.treatment.toJSON() : <any>undefined;
        data["legality"] = this.legality;
        return data;
    }
}

export interface IMagicCard {
    id?: string;
    name?: string | undefined;
    altName?: string | undefined;
    game?: GameType;
    itemType?: ItemType;
    oracleId?: string;
    mvId?: number;
    scryfallId?: string | undefined;
    tcgplayerId?: number | undefined;
    setIndex: string | undefined;
    set: MagicSet;
    rarity: RarityType;
    releaseDate?: Date;
    layout?: LayoutType;
    manaValue?: number;
    colorMask: number;
    manaMask?: number | undefined;
    faces?: MagicCardFace[] | undefined;
    treatment: MagicCardTreatment;
    legality: number;
}

export class MagicCardFace implements IMagicCardFace {
    name!: string | undefined;
    flavorName?: string | undefined;
    isFront?: boolean;
    manaCost!: string | undefined;
    typeLine?: string | undefined;
    oracleText?: string | undefined;
    flavorText?: string | undefined;
    localizedName?: string | undefined;
    localizedTypeLine?: string | undefined;
    localizedText?: string | undefined;
    power?: string | undefined;
    toughness?: string | undefined;
    artist?: Artist;

    constructor(data?: IMagicCardFace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.flavorName = _data["flavorName"];
            this.isFront = _data["isFront"];
            this.manaCost = _data["manaCost"];
            this.typeLine = _data["typeLine"];
            this.oracleText = _data["oracleText"];
            this.flavorText = _data["flavorText"];
            this.localizedName = _data["localizedName"];
            this.localizedTypeLine = _data["localizedTypeLine"];
            this.localizedText = _data["localizedText"];
            this.power = _data["power"];
            this.toughness = _data["toughness"];
            this.artist = _data["artist"] ? Artist.fromJS(_data["artist"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MagicCardFace {
        data = typeof data === 'object' ? data : {};
        let result = new MagicCardFace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["flavorName"] = this.flavorName;
        data["isFront"] = this.isFront;
        data["manaCost"] = this.manaCost;
        data["typeLine"] = this.typeLine;
        data["oracleText"] = this.oracleText;
        data["flavorText"] = this.flavorText;
        data["localizedName"] = this.localizedName;
        data["localizedTypeLine"] = this.localizedTypeLine;
        data["localizedText"] = this.localizedText;
        data["power"] = this.power;
        data["toughness"] = this.toughness;
        data["artist"] = this.artist ? this.artist.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMagicCardFace {
    name: string | undefined;
    flavorName?: string | undefined;
    isFront?: boolean;
    manaCost: string | undefined;
    typeLine?: string | undefined;
    oracleText?: string | undefined;
    flavorText?: string | undefined;
    localizedName?: string | undefined;
    localizedTypeLine?: string | undefined;
    localizedText?: string | undefined;
    power?: string | undefined;
    toughness?: string | undefined;
    artist?: Artist;
}

export class MagicCardForStats implements IMagicCardForStats {
    name!: string | undefined;
    releaseDate!: Date;
    setCode!: string | undefined;
    count!: number;
    specialCount!: number;
    value!: number;
    specialValue!: number;

    constructor(data?: IMagicCardForStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            this.setCode = _data["setCode"];
            this.count = _data["count"];
            this.specialCount = _data["specialCount"];
            this.value = _data["value"];
            this.specialValue = _data["specialValue"];
        }
    }

    static fromJS(data: any): MagicCardForStats {
        data = typeof data === 'object' ? data : {};
        let result = new MagicCardForStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["releaseDate"] = this.releaseDate ? formatDate(this.releaseDate) : <any>undefined;
        data["setCode"] = this.setCode;
        data["count"] = this.count;
        data["specialCount"] = this.specialCount;
        data["value"] = this.value;
        data["specialValue"] = this.specialValue;
        return data;
    }
}

export interface IMagicCardForStats {
    name: string | undefined;
    releaseDate: Date;
    setCode: string | undefined;
    count: number;
    specialCount: number;
    value: number;
    specialValue: number;
}

export class MagicCardRuling implements IMagicCardRuling {
    date!: Date;
    text!: string | undefined;

    constructor(data?: IMagicCardRuling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): MagicCardRuling {
        data = typeof data === 'object' ? data : {};
        let result = new MagicCardRuling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["text"] = this.text;
        return data;
    }
}

export interface IMagicCardRuling {
    date: Date;
    text: string | undefined;
}

export class MagicCardTreatment implements IMagicCardTreatment {
    normal!: boolean;
    special!: boolean;
    other?: string[] | undefined;

    constructor(data?: IMagicCardTreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.normal = _data["normal"];
            this.special = _data["special"];
            if (Array.isArray(_data["other"])) {
                this.other = [] as any;
                for (let item of _data["other"])
                    this.other!.push(item);
            }
        }
    }

    static fromJS(data: any): MagicCardTreatment {
        data = typeof data === 'object' ? data : {};
        let result = new MagicCardTreatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["normal"] = this.normal;
        data["special"] = this.special;
        if (Array.isArray(this.other)) {
            data["other"] = [];
            for (let item of this.other)
                data["other"].push(item);
        }
        return data;
    }
}

export interface IMagicCardTreatment {
    normal: boolean;
    special: boolean;
    other?: string[] | undefined;
}

export class MagicSearch implements IMagicSearch {
    oracleId?: string | undefined;
    scryfallId?: string | undefined;
    sets?: string[] | undefined;

    constructor(data?: IMagicSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oracleId = _data["oracleId"];
            this.scryfallId = _data["scryfallId"];
            if (Array.isArray(_data["sets"])) {
                this.sets = [] as any;
                for (let item of _data["sets"])
                    this.sets!.push(item);
            }
        }
    }

    static fromJS(data: any): MagicSearch {
        data = typeof data === 'object' ? data : {};
        let result = new MagicSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oracleId"] = this.oracleId;
        data["scryfallId"] = this.scryfallId;
        if (Array.isArray(this.sets)) {
            data["sets"] = [];
            for (let item of this.sets)
                data["sets"].push(item);
        }
        return data;
    }
}

export interface IMagicSearch {
    oracleId?: string | undefined;
    scryfallId?: string | undefined;
    sets?: string[] | undefined;
}

export class MagicSet implements IMagicSet {
    id!: string;
    code!: string | undefined;
    name!: string | undefined;
    releaseDate!: Date;
    parentId?: string | undefined;
    parentSet?: MagicSet;
    blockId?: string | undefined;
    block?: MagicBlock;
    cardCount?: number | undefined;
    type?: MagicSetType;
    ub?: boolean | undefined;

    constructor(data?: IMagicSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            this.parentId = _data["parentId"];
            this.parentSet = _data["parentSet"] ? MagicSet.fromJS(_data["parentSet"]) : <any>undefined;
            this.blockId = _data["blockId"];
            this.block = _data["block"] ? MagicBlock.fromJS(_data["block"]) : <any>undefined;
            this.cardCount = _data["cardCount"];
            this.type = _data["type"];
            this.ub = _data["ub"];
        }
    }

    static fromJS(data: any): MagicSet {
        data = typeof data === 'object' ? data : {};
        let result = new MagicSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["releaseDate"] = this.releaseDate ? formatDate(this.releaseDate) : <any>undefined;
        data["parentId"] = this.parentId;
        data["parentSet"] = this.parentSet ? this.parentSet.toJSON() : <any>undefined;
        data["blockId"] = this.blockId;
        data["block"] = this.block ? this.block.toJSON() : <any>undefined;
        data["cardCount"] = this.cardCount;
        data["type"] = this.type;
        data["ub"] = this.ub;
        return data;
    }
}

export interface IMagicSet {
    id: string;
    code: string | undefined;
    name: string | undefined;
    releaseDate: Date;
    parentId?: string | undefined;
    parentSet?: MagicSet;
    blockId?: string | undefined;
    block?: MagicBlock;
    cardCount?: number | undefined;
    type?: MagicSetType;
    ub?: boolean | undefined;
}

export class MagicSetForStats implements IMagicSetForStats {
    setName!: string | undefined;
    setCode!: string | undefined;
    cardCount!: number;
    distinctCardCount!: number;

    constructor(data?: IMagicSetForStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setName = _data["setName"];
            this.setCode = _data["setCode"];
            this.cardCount = _data["cardCount"];
            this.distinctCardCount = _data["distinctCardCount"];
        }
    }

    static fromJS(data: any): MagicSetForStats {
        data = typeof data === 'object' ? data : {};
        let result = new MagicSetForStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setName"] = this.setName;
        data["setCode"] = this.setCode;
        data["cardCount"] = this.cardCount;
        data["distinctCardCount"] = this.distinctCardCount;
        return data;
    }
}

export interface IMagicSetForStats {
    setName: string | undefined;
    setCode: string | undefined;
    cardCount: number;
    distinctCardCount: number;
}

export enum MagicSetType {
    Unknown = "Unknown",
    Alchemy = "Alchemy",
    Archenemy = "Archenemy",
    Arsenal = "Arsenal",
    Box = "Box",
    Commander = "Commander",
    Core = "Core",
    DraftInnovation = "DraftInnovation",
    DuelDeck = "DuelDeck",
    Expansion = "Expansion",
    FromTheVault = "FromTheVault",
    Funny = "Funny",
    Masterpiece = "Masterpiece",
    Masters = "Masters",
    Memorabilia = "Memorabilia",
    Minigame = "Minigame",
    Planechase = "Planechase",
    PremiumDeck = "PremiumDeck",
    Promo = "Promo",
    Spellbook = "Spellbook",
    Starter = "Starter",
    Token = "Token",
    TreasureChest = "TreasureChest",
    Vanguard = "Vanguard",
}

export class NewsPost implements INewsPost {
    id!: string;
    createdAt!: Date;
    modifiedAt?: Date | undefined;
    author!: PostAuthor;
    title!: string | undefined;
    content!: string | undefined;
    truncated?: boolean | undefined;

    constructor(data?: INewsPost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.author = new PostAuthor();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.author = _data["author"] ? PostAuthor.fromJS(_data["author"]) : new PostAuthor();
            this.title = _data["title"];
            this.content = _data["content"];
            this.truncated = _data["truncated"];
        }
    }

    static fromJS(data: any): NewsPost {
        data = typeof data === 'object' ? data : {};
        let result = new NewsPost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["author"] = this.author ? this.author.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["content"] = this.content;
        data["truncated"] = this.truncated;
        return data;
    }
}

export interface INewsPost {
    id: string;
    createdAt: Date;
    modifiedAt?: Date | undefined;
    author: PostAuthor;
    title: string | undefined;
    content: string | undefined;
    truncated?: boolean | undefined;
}

export class NewsPostStub implements INewsPostStub {
    id!: string;
    createdAt!: Date;
    modifiedAt?: Date | undefined;
    title!: string | undefined;

    constructor(data?: INewsPostStub) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): NewsPostStub {
        data = typeof data === 'object' ? data : {};
        let result = new NewsPostStub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["title"] = this.title;
        return data;
    }
}

export interface INewsPostStub {
    id: string;
    createdAt: Date;
    modifiedAt?: Date | undefined;
    title: string | undefined;
}

export class Notification implements INotification {
    id!: string;
    type!: NotificationType;
    message?: string | undefined;
    linkedPost?: string | undefined;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.message = _data["message"];
            this.linkedPost = _data["linkedPost"];
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["message"] = this.message;
        data["linkedPost"] = this.linkedPost;
        return data;
    }
}

export interface INotification {
    id: string;
    type: NotificationType;
    message?: string | undefined;
    linkedPost?: string | undefined;
}

export enum NotificationType {
    Global = "Global",
    FriendPending = "FriendPending",
}

export class PostAuthor implements IPostAuthor {
    id!: string;
    username!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: IPostAuthor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PostAuthor {
        data = typeof data === 'object' ? data : {};
        let result = new PostAuthor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IPostAuthor {
    id: string;
    username: string | undefined;
    displayName: string | undefined;
}

export class PreviewGameData implements IPreviewGameData {
    magic?: MagicCard;

    constructor(data?: IPreviewGameData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.magic = _data["magic"] ? MagicCard.fromJS(_data["magic"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PreviewGameData {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewGameData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["magic"] = this.magic ? this.magic.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPreviewGameData {
    magic?: MagicCard;
}

export class PreviewItem implements IPreviewItem {
    id?: string;
    name?: string | undefined;
    altName?: string | undefined;
    game?: GameType;
    itemType?: ItemType;
    url?: string | undefined;
    transformation?: TransformationType;
    data?: PreviewGameData;

    constructor(data?: IPreviewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.altName = _data["altName"];
            this.game = _data["game"];
            this.itemType = _data["itemType"];
            this.url = _data["url"];
            this.transformation = _data["transformation"];
            this.data = _data["data"] ? PreviewGameData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PreviewItem {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["altName"] = this.altName;
        data["game"] = this.game;
        data["itemType"] = this.itemType;
        data["url"] = this.url;
        data["transformation"] = this.transformation;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPreviewItem {
    id?: string;
    name?: string | undefined;
    altName?: string | undefined;
    game?: GameType;
    itemType?: ItemType;
    url?: string | undefined;
    transformation?: TransformationType;
    data?: PreviewGameData;
}

export class Price implements IPrice {
    normalUSD!: number;
    specialUSD!: number;

    constructor(data?: IPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.normalUSD = _data["normalUSD"];
            this.specialUSD = _data["specialUSD"];
        }
    }

    static fromJS(data: any): Price {
        data = typeof data === 'object' ? data : {};
        let result = new Price();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["normalUSD"] = this.normalUSD;
        data["specialUSD"] = this.specialUSD;
        return data;
    }
}

export interface IPrice {
    normalUSD: number;
    specialUSD: number;
}

export class ProfileChanges implements IProfileChanges {
    displayName?: string | undefined;
    about?: string | undefined;
    location?: string | undefined;
    website?: string | undefined;
    website2?: string | undefined;
    website3?: string | undefined;

    constructor(data?: IProfileChanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.about = _data["about"];
            this.location = _data["location"];
            this.website = _data["website"];
            this.website2 = _data["website2"];
            this.website3 = _data["website3"];
        }
    }

    static fromJS(data: any): ProfileChanges {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileChanges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["about"] = this.about;
        data["location"] = this.location;
        data["website"] = this.website;
        data["website2"] = this.website2;
        data["website3"] = this.website3;
        return data;
    }
}

export interface IProfileChanges {
    displayName?: string | undefined;
    about?: string | undefined;
    location?: string | undefined;
    website?: string | undefined;
    website2?: string | undefined;
    website3?: string | undefined;
}

export class RangeParameter implements IRangeParameter {
    min!: number;
    max!: number;

    constructor(data?: IRangeParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): RangeParameter {
        data = typeof data === 'object' ? data : {};
        let result = new RangeParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        return data;
    }
}

export interface IRangeParameter {
    min: number;
    max: number;
}

export enum RarityType {
    Unknown = "Unknown",
    Common = "Common",
    Uncommon = "Uncommon",
    Rare = "Rare",
    Mythic = "Mythic",
    Special = "Special",
    Bonus = "Bonus",
}

export class SearchRequest implements ISearchRequest {
    game?: GameType;
    start?: number;
    limit?: number;
    item?: ItemSearch;
    artist?: ArtistSearch;
    magic?: MagicSearch;

    constructor(data?: ISearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.game = _data["game"];
            this.start = _data["start"];
            this.limit = _data["limit"];
            this.item = _data["item"] ? ItemSearch.fromJS(_data["item"]) : <any>undefined;
            this.artist = _data["artist"] ? ArtistSearch.fromJS(_data["artist"]) : <any>undefined;
            this.magic = _data["magic"] ? MagicSearch.fromJS(_data["magic"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["game"] = this.game;
        data["start"] = this.start;
        data["limit"] = this.limit;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["artist"] = this.artist ? this.artist.toJSON() : <any>undefined;
        data["magic"] = this.magic ? this.magic.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchRequest {
    game?: GameType;
    start?: number;
    limit?: number;
    item?: ItemSearch;
    artist?: ArtistSearch;
    magic?: MagicSearch;
}

export class SearchResponse implements ISearchResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    count?: number;
    isExact?: boolean;
    results?: CollectedPreviewItem[] | undefined;

    constructor(data?: ISearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.count = _data["count"];
            this.isExact = _data["isExact"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CollectedPreviewItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["count"] = this.count;
        data["isExact"] = this.isExact;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    count?: number;
    isExact?: boolean;
    results?: CollectedPreviewItem[] | undefined;
}

export enum SearchTermType {
    Unknown = "Unknown",
    Item = "Item",
    Release = "Release",
    Artist = "Artist",
    Deck = "Deck",
}

export class SimpleSearchRequest implements ISimpleSearchRequest {
    term!: string | undefined;
    game?: GameType;
    itemType?: ItemType;
    searchTermType?: SearchTermType;

    constructor(data?: ISimpleSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.term = _data["term"];
            this.game = _data["game"];
            this.itemType = _data["itemType"];
            this.searchTermType = _data["searchTermType"];
        }
    }

    static fromJS(data: any): SimpleSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        data["game"] = this.game;
        data["itemType"] = this.itemType;
        data["searchTermType"] = this.searchTermType;
        return data;
    }
}

export interface ISimpleSearchRequest {
    term: string | undefined;
    game?: GameType;
    itemType?: ItemType;
    searchTermType?: SearchTermType;
}

export class SimpleSearchResponse implements ISimpleSearchResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    results?: SimpleSearchTerm[] | undefined;

    constructor(data?: ISimpleSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SimpleSearchTerm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISimpleSearchResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    results?: SimpleSearchTerm[] | undefined;
}

export class SimpleSearchTerm implements ISimpleSearchTerm {
    term!: string | undefined;
    game!: GameType;
    itemType!: ItemType;
    searchTermType!: SearchTermType;
    navigatesTo?: string | undefined;

    constructor(data?: ISimpleSearchTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.term = _data["term"];
            this.game = _data["game"];
            this.itemType = _data["itemType"];
            this.searchTermType = _data["searchTermType"];
            this.navigatesTo = _data["navigatesTo"];
        }
    }

    static fromJS(data: any): SimpleSearchTerm {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleSearchTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        data["game"] = this.game;
        data["itemType"] = this.itemType;
        data["searchTermType"] = this.searchTermType;
        data["navigatesTo"] = this.navigatesTo;
        return data;
    }
}

export interface ISimpleSearchTerm {
    term: string | undefined;
    game: GameType;
    itemType: ItemType;
    searchTermType: SearchTermType;
    navigatesTo?: string | undefined;
}

export enum TransformationType {
    None = "None",
    Flip = "Flip",
    Rotate90 = "Rotate90",
    Rotate180 = "Rotate180",
}

export class UndoUserCollectionActionsRequest implements IUndoUserCollectionActionsRequest {
    actions!: UserCollectionAction[] | undefined;

    constructor(data?: IUndoUserCollectionActionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(UserCollectionAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UndoUserCollectionActionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UndoUserCollectionActionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUndoUserCollectionActionsRequest {
    actions: UserCollectionAction[] | undefined;
}

export class UpdateDeckRequest implements IUpdateDeckRequest {
    deckId!: string;
    deckChanges?: DeckChanges;
    cardChanges?: DeckCardChanges[] | undefined;
    cardAdditions?: DeckCardAddition[] | undefined;

    constructor(data?: IUpdateDeckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deckId = _data["deckId"];
            this.deckChanges = _data["deckChanges"] ? DeckChanges.fromJS(_data["deckChanges"]) : <any>undefined;
            if (Array.isArray(_data["cardChanges"])) {
                this.cardChanges = [] as any;
                for (let item of _data["cardChanges"])
                    this.cardChanges!.push(DeckCardChanges.fromJS(item));
            }
            if (Array.isArray(_data["cardAdditions"])) {
                this.cardAdditions = [] as any;
                for (let item of _data["cardAdditions"])
                    this.cardAdditions!.push(DeckCardAddition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDeckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDeckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deckId"] = this.deckId;
        data["deckChanges"] = this.deckChanges ? this.deckChanges.toJSON() : <any>undefined;
        if (Array.isArray(this.cardChanges)) {
            data["cardChanges"] = [];
            for (let item of this.cardChanges)
                data["cardChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.cardAdditions)) {
            data["cardAdditions"] = [];
            for (let item of this.cardAdditions)
                data["cardAdditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateDeckRequest {
    deckId: string;
    deckChanges?: DeckChanges;
    cardChanges?: DeckCardChanges[] | undefined;
    cardAdditions?: DeckCardAddition[] | undefined;
}

export class UpdateDeckResponse implements IUpdateDeckResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    deckId!: string;
    cardAdditions?: DeckCardAdditionResult[] | undefined;

    constructor(data?: IUpdateDeckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.deckId = _data["deckId"];
            if (Array.isArray(_data["cardAdditions"])) {
                this.cardAdditions = [] as any;
                for (let item of _data["cardAdditions"])
                    this.cardAdditions!.push(DeckCardAdditionResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDeckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDeckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["deckId"] = this.deckId;
        if (Array.isArray(this.cardAdditions)) {
            data["cardAdditions"] = [];
            for (let item of this.cardAdditions)
                data["cardAdditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateDeckResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    deckId: string;
    cardAdditions?: DeckCardAdditionResult[] | undefined;
}

export class UpdateMagicCardChanges implements IUpdateMagicCardChanges {
    updateImage?: boolean | undefined;
    moveToSet?: string | undefined;

    constructor(data?: IUpdateMagicCardChanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateImage = _data["updateImage"];
            this.moveToSet = _data["moveToSet"];
        }
    }

    static fromJS(data: any): UpdateMagicCardChanges {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMagicCardChanges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateImage"] = this.updateImage;
        data["moveToSet"] = this.moveToSet;
        return data;
    }
}

export interface IUpdateMagicCardChanges {
    updateImage?: boolean | undefined;
    moveToSet?: string | undefined;
}

export class UpdateMagicCardRequest implements IUpdateMagicCardRequest {
    magicCardId!: string;
    changes!: UpdateMagicCardChanges;

    constructor(data?: IUpdateMagicCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.changes = new UpdateMagicCardChanges();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.magicCardId = _data["magicCardId"];
            this.changes = _data["changes"] ? UpdateMagicCardChanges.fromJS(_data["changes"]) : new UpdateMagicCardChanges();
        }
    }

    static fromJS(data: any): UpdateMagicCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMagicCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["magicCardId"] = this.magicCardId;
        data["changes"] = this.changes ? this.changes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateMagicCardRequest {
    magicCardId: string;
    changes: UpdateMagicCardChanges;
}

export class UpdateNewsPostRequest implements IUpdateNewsPostRequest {
    post!: NewsPost;

    constructor(data?: IUpdateNewsPostRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.post = new NewsPost();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.post = _data["post"] ? NewsPost.fromJS(_data["post"]) : new NewsPost();
        }
    }

    static fromJS(data: any): UpdateNewsPostRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNewsPostRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["post"] = this.post ? this.post.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateNewsPostRequest {
    post: NewsPost;
}

export class UpdateUserPrivacySettingsRequest implements IUpdateUserPrivacySettingsRequest {
    profileVisibility?: VisibilityType;
    collectionVisibility?: VisibilityType;
    decksVisibility?: VisibilityType;
    statsVisibility?: VisibilityType;
    allowFriendRequests?: boolean | undefined;

    constructor(data?: IUpdateUserPrivacySettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileVisibility = _data["profileVisibility"];
            this.collectionVisibility = _data["collectionVisibility"];
            this.decksVisibility = _data["decksVisibility"];
            this.statsVisibility = _data["statsVisibility"];
            this.allowFriendRequests = _data["allowFriendRequests"];
        }
    }

    static fromJS(data: any): UpdateUserPrivacySettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPrivacySettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileVisibility"] = this.profileVisibility;
        data["collectionVisibility"] = this.collectionVisibility;
        data["decksVisibility"] = this.decksVisibility;
        data["statsVisibility"] = this.statsVisibility;
        data["allowFriendRequests"] = this.allowFriendRequests;
        return data;
    }
}

export interface IUpdateUserPrivacySettingsRequest {
    profileVisibility?: VisibilityType;
    collectionVisibility?: VisibilityType;
    decksVisibility?: VisibilityType;
    statsVisibility?: VisibilityType;
    allowFriendRequests?: boolean | undefined;
}

export class UpdateUserPrivacySettingsResponse implements IUpdateUserPrivacySettingsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    wasUpdated?: boolean | undefined;
    updatedSettings?: UserPrivacySettings;

    constructor(data?: IUpdateUserPrivacySettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            this.wasUpdated = _data["wasUpdated"];
            this.updatedSettings = _data["updatedSettings"] ? UserPrivacySettings.fromJS(_data["updatedSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateUserPrivacySettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPrivacySettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["wasUpdated"] = this.wasUpdated;
        data["updatedSettings"] = this.updatedSettings ? this.updatedSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateUserPrivacySettingsResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    wasUpdated?: boolean | undefined;
    updatedSettings?: UserPrivacySettings;
}

export class UpdateUserProfileRequest implements IUpdateUserProfileRequest {
    username!: string | undefined;
    profileChanges!: ProfileChanges;

    constructor(data?: IUpdateUserProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.profileChanges = new ProfileChanges();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.profileChanges = _data["profileChanges"] ? ProfileChanges.fromJS(_data["profileChanges"]) : new ProfileChanges();
        }
    }

    static fromJS(data: any): UpdateUserProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["profileChanges"] = this.profileChanges ? this.profileChanges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateUserProfileRequest {
    username: string | undefined;
    profileChanges: ProfileChanges;
}

export class User implements IUser {
    id!: string;
    createdAt!: Date;
    username!: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    status!: UserStatusType;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.username = _data["username"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["status"] = this.status;
        return data;
    }
}

export interface IUser {
    id: string;
    createdAt: Date;
    username: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    status: UserStatusType;
}

export class UserAndProfile implements IUserAndProfile {
    user!: User;
    profile!: UserProfile;
    role!: UserRoleType;

    constructor(data?: IUserAndProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new User();
            this.profile = new UserProfile();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : new User();
            this.profile = _data["profile"] ? UserProfile.fromJS(_data["profile"]) : new UserProfile();
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UserAndProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserAndProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["role"] = this.role;
        return data;
    }
}

export interface IUserAndProfile {
    user: User;
    profile: UserProfile;
    role: UserRoleType;
}

export class UserCollectionAction implements IUserCollectionAction {
    actionId!: string;
    datetime!: Date;
    itemId!: string;
    collectionItemId?: string | undefined;
    itemName!: string | undefined;
    prevCount!: number;
    prevSpecialCount!: number;
    prevProxyCount!: number;
    countDelta?: number | undefined;
    specialCountDelta?: number | undefined;
    proxyCountDelta?: number | undefined;

    constructor(data?: IUserCollectionAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionId = _data["actionId"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.itemId = _data["itemId"];
            this.collectionItemId = _data["collectionItemId"];
            this.itemName = _data["itemName"];
            this.prevCount = _data["prevCount"];
            this.prevSpecialCount = _data["prevSpecialCount"];
            this.prevProxyCount = _data["prevProxyCount"];
            this.countDelta = _data["countDelta"];
            this.specialCountDelta = _data["specialCountDelta"];
            this.proxyCountDelta = _data["proxyCountDelta"];
        }
    }

    static fromJS(data: any): UserCollectionAction {
        data = typeof data === 'object' ? data : {};
        let result = new UserCollectionAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionId"] = this.actionId;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["itemId"] = this.itemId;
        data["collectionItemId"] = this.collectionItemId;
        data["itemName"] = this.itemName;
        data["prevCount"] = this.prevCount;
        data["prevSpecialCount"] = this.prevSpecialCount;
        data["prevProxyCount"] = this.prevProxyCount;
        data["countDelta"] = this.countDelta;
        data["specialCountDelta"] = this.specialCountDelta;
        data["proxyCountDelta"] = this.proxyCountDelta;
        return data;
    }
}

export interface IUserCollectionAction {
    actionId: string;
    datetime: Date;
    itemId: string;
    collectionItemId?: string | undefined;
    itemName: string | undefined;
    prevCount: number;
    prevSpecialCount: number;
    prevProxyCount: number;
    countDelta?: number | undefined;
    specialCountDelta?: number | undefined;
    proxyCountDelta?: number | undefined;
}

export class UserContactSettings implements IUserContactSettings {
    allowFriendRequests!: boolean;

    constructor(data?: IUserContactSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowFriendRequests = _data["allowFriendRequests"];
        }
    }

    static fromJS(data: any): UserContactSettings {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowFriendRequests"] = this.allowFriendRequests;
        return data;
    }
}

export interface IUserContactSettings {
    allowFriendRequests: boolean;
}

export class UserPrivacySettings implements IUserPrivacySettings {
    visibility!: UserVisibilitySettings;
    userContact!: UserContactSettings;

    constructor(data?: IUserPrivacySettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.visibility = new UserVisibilitySettings();
            this.userContact = new UserContactSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visibility = _data["visibility"] ? UserVisibilitySettings.fromJS(_data["visibility"]) : new UserVisibilitySettings();
            this.userContact = _data["userContact"] ? UserContactSettings.fromJS(_data["userContact"]) : new UserContactSettings();
        }
    }

    static fromJS(data: any): UserPrivacySettings {
        data = typeof data === 'object' ? data : {};
        let result = new UserPrivacySettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visibility"] = this.visibility ? this.visibility.toJSON() : <any>undefined;
        data["userContact"] = this.userContact ? this.userContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserPrivacySettings {
    visibility: UserVisibilitySettings;
    userContact: UserContactSettings;
}

export class UserProfile implements IUserProfile {
    id!: string;
    about?: string | undefined;
    location?: string | undefined;
    website?: string | undefined;
    website2?: string | undefined;
    website3?: string | undefined;

    constructor(data?: IUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.about = _data["about"];
            this.location = _data["location"];
            this.website = _data["website"];
            this.website2 = _data["website2"];
            this.website3 = _data["website3"];
        }
    }

    static fromJS(data: any): UserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["about"] = this.about;
        data["location"] = this.location;
        data["website"] = this.website;
        data["website2"] = this.website2;
        data["website3"] = this.website3;
        return data;
    }
}

export interface IUserProfile {
    id: string;
    about?: string | undefined;
    location?: string | undefined;
    website?: string | undefined;
    website2?: string | undefined;
    website3?: string | undefined;
}

export enum UserProtectedResource {
    None = "None",
    Profile = "Profile",
    Collection = "Collection",
    Decks = "Decks",
    Stats = "Stats",
}

export class UserRelationship implements IUserRelationship {
    userId!: string;
    username!: string | undefined;
    otherUserId!: string;
    otherUsername!: string | undefined;
    otherDisplayName?: string | undefined;
    initiatorId!: string;
    lastModified!: Date;
    type!: UserRelationshipType;

    constructor(data?: IUserRelationship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.otherUserId = _data["otherUserId"];
            this.otherUsername = _data["otherUsername"];
            this.otherDisplayName = _data["otherDisplayName"];
            this.initiatorId = _data["initiatorId"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UserRelationship {
        data = typeof data === 'object' ? data : {};
        let result = new UserRelationship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["otherUserId"] = this.otherUserId;
        data["otherUsername"] = this.otherUsername;
        data["otherDisplayName"] = this.otherDisplayName;
        data["initiatorId"] = this.initiatorId;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

export interface IUserRelationship {
    userId: string;
    username: string | undefined;
    otherUserId: string;
    otherUsername: string | undefined;
    otherDisplayName?: string | undefined;
    initiatorId: string;
    lastModified: Date;
    type: UserRelationshipType;
}

export enum UserRelationshipType {
    None = "None",
    Pending = "Pending",
    Friends = "Friends",
    Blocked = "Blocked",
}

export enum UserRoleType {
    None = "None",
    User = "User",
    UserPlus = "UserPlus",
    Moderator = "Moderator",
    Administrator = "Administrator",
}

export enum UserSearchContext {
    General = "General",
    AddFriend = "AddFriend",
    BlockUser = "BlockUser",
}

export class UserSearchResponse implements IUserSearchResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    results?: UserSearchResult[] | undefined;

    constructor(data?: IUserSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
            this.performance = _data["performance"] ? DataPerformance.fromJS(_data["performance"]) : <any>undefined;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserSearchResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserSearchResponse {
    success?: boolean;
    error?: string | undefined;
    performance?: DataPerformance;
    results?: UserSearchResult[] | undefined;
}

export class UserSearchResult implements IUserSearchResult {
    userId!: string;
    username!: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IUserSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserSearchResult {
    userId: string;
    username: string | undefined;
    displayName?: string | undefined;
}

export enum UserStatusType {
    Active = "Active",
    Inactive = "Inactive",
    Deleted = "Deleted",
}

export class UserVisibilitySettings implements IUserVisibilitySettings {
    profile!: VisibilityType;
    collection!: VisibilityType;
    decks!: VisibilityType;
    stats!: VisibilityType;

    constructor(data?: IUserVisibilitySettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"];
            this.collection = _data["collection"];
            this.decks = _data["decks"];
            this.stats = _data["stats"];
        }
    }

    static fromJS(data: any): UserVisibilitySettings {
        data = typeof data === 'object' ? data : {};
        let result = new UserVisibilitySettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile;
        data["collection"] = this.collection;
        data["decks"] = this.decks;
        data["stats"] = this.stats;
        return data;
    }
}

export interface IUserVisibilitySettings {
    profile: VisibilityType;
    collection: VisibilityType;
    decks: VisibilityType;
    stats: VisibilityType;
}

export class ViaCollection implements IViaCollection {
    username!: string | undefined;

    constructor(data?: IViaCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): ViaCollection {
        data = typeof data === 'object' ? data : {};
        let result = new ViaCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IViaCollection {
    username: string | undefined;
}

export class ViaName implements IViaName {
    name!: string | undefined;

    constructor(data?: IViaName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ViaName {
        data = typeof data === 'object' ? data : {};
        let result = new ViaName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IViaName {
    name: string | undefined;
}

export class ViaSet implements IViaSet {
    setCode!: string | undefined;
    setIndex?: string | undefined;

    constructor(data?: IViaSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setCode = _data["setCode"];
            this.setIndex = _data["setIndex"];
        }
    }

    static fromJS(data: any): ViaSet {
        data = typeof data === 'object' ? data : {};
        let result = new ViaSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setCode"] = this.setCode;
        data["setIndex"] = this.setIndex;
        return data;
    }
}

export interface IViaSet {
    setCode: string | undefined;
    setIndex?: string | undefined;
}

export enum VisibilityType {
    Public = "Public",
    Friends = "Friends",
    Private = "Private",
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}